import type { AspidaClient, BasicHeaders } from 'aspida'
import { dataToURLString } from 'aspida'

import type { Methods as Methods0 } from './admin/categories'
import type { Methods as Methods2 } from './admin/categories-localizations'
import type { Methods as Methods1 } from './admin/categories/_categoryId@string'
import type { Methods as Methods3 } from './admin/comments'
import type { Methods as Methods4 } from './admin/comments/ban/_commentId@string'
import type { Methods as Methods5 } from './admin/creator-categories'
import type { Methods as Methods7 } from './admin/creator-categories-localizations'
import type { Methods as Methods6 } from './admin/creator-categories/_categoryId@string'
import type { Methods as Methods8 } from './admin/creator-job-localizations'
import type { Methods as Methods9 } from './admin/creators'
import type { Methods as Methods10 } from './admin/creators/_creatorId@string'
import type { Methods as Methods11 } from './admin/display-formats-master'
import type { Methods as Methods12 } from './admin/episodes/_workId@string/_seasonId@string'
import type { Methods as Methods13 } from './admin/episodes/_workId@string/_seasonId@string/_episodeId@string'
import type { Methods as Methods14 } from './admin/jobs'
import type { Methods as Methods15 } from './admin/jobs/_jobId@string'
import type { Methods as Methods16 } from './admin/list-patterns-master'
import type { Methods as Methods17 } from './admin/modals'
import type { Methods as Methods18 } from './admin/modals/_id@string'
import type { Methods as Methods19 } from './admin/modals/display_order'
import type { Methods as Methods20 } from './admin/news'
import type { Methods as Methods21 } from './admin/news/_newsId@string'
import type { Methods as Methods22 } from './admin/news/push-notifications'
import type { Methods as Methods23 } from './admin/notification-histories'
import type { Methods as Methods24 } from './admin/notifications/send'
import type { Methods as Methods25 } from './admin/seasons'
import type { Methods as Methods26 } from './admin/seasons/_workId@string'
import type { Methods as Methods27 } from './admin/seasons/_workId@string/_seasonId@string'
import type { Methods as Methods28 } from './admin/topics'
import type { Methods as Methods29 } from './admin/topics/_id@string'
import type { Methods as Methods30 } from './admin/topics/display_order'
import type { Methods as Methods31 } from './admin/transitions-master'
import type { Methods as Methods32 } from './admin/unnotified-items/_notificationType@string'
import type { Methods as Methods33 } from './admin/user-notifications/test'
import type { Methods as Methods34 } from './admin/users'
import type { Methods as Methods35 } from './admin/users/_userId@string'
import type { Methods as Methods36 } from './admin/users/ban/_userId@string'
import type { Methods as Methods37 } from './admin/works'
import type { Methods as Methods38 } from './admin/works/_workId@string'
import type { Methods as Methods39 } from './avatars'
import type { Methods as Methods40 } from './banners/_id@string'
import type { Methods as Methods41 } from './billing-items'
import type { Methods as Methods42 } from './campaigns/_campaignId@string'
import type { Methods as Methods43 } from './campaigns/active'
import type { Methods as Methods44 } from './coin/purchase'
import type { Methods as Methods45 } from './comments'
import type { Methods as Methods46 } from './comments/episodes/_episodeId@string'
import type { Methods as Methods47 } from './comments/seasons/_projectMasterId@string/_seasonId@string'
import type { Methods as Methods48 } from './commercial/available-counts'
import type { Methods as Methods49 } from './contacts'
import type { Methods as Methods50 } from './creators'
import type { Methods as Methods51 } from './creators/_creatorId@string'
import type { Methods as Methods52 } from './creators/_creatorId@string/support'
import type { Methods as Methods53 } from './episodes/_episodeId@string'
import type { Methods as Methods54 } from './episodes/_episodeId@string/use-commercial'
import type { Methods as Methods55 } from './episodes/_episodeId@string/use-free-ticket'
import type { Methods as Methods56 } from './episodes/order-create'
import type { Methods as Methods57 } from './episodes/purchased'
import type { Methods as Methods58 } from './episodes/purchased/_projectMasterId@string'
import type { Methods as Methods59 } from './episodes/purchased/bulk'
import type { Methods as Methods60 } from './episodes/seasons/_seasonId@string'
import type { Methods as Methods61 } from './episodes/viewing-histories'
import type { Methods as Methods62 } from './favorite-episodes'
import type { Methods as Methods63 } from './favorite-episodes/_id@string'
import type { Methods as Methods64 } from './favorite-episodes/episodes/_episodeId@string'
import type { Methods as Methods65 } from './favorite-seasons'
import type { Methods as Methods66 } from './favorite-seasons/_id@string'
import type { Methods as Methods67 } from './favorite-seasons/seasons/_seasonId@string'
import type { Methods as Methods68 } from './get-coin-history'
import type { Methods as Methods69 } from './goods'
import type { Methods as Methods70 } from './goods/comments/_commentId@string'
import type { Methods as Methods71 } from './health-check'
import type { Methods as Methods72 } from './holding-coin'
import type { Methods as Methods73 } from './invite'
import type { Methods as Methods74 } from './main-favorite-episodes'
import type { Methods as Methods75 } from './main-favorite-seasons'
import type { Methods as Methods76 } from './main-viewing-episodes-histories'
import type { Methods as Methods77 } from './main-viewing-seasons-histories'
import type { Methods as Methods78 } from './making-favorite-episodes'
import type { Methods as Methods79 } from './making-favorite-seasons'
import type { Methods as Methods80 } from './making-viewing-episodes-histories'
import type { Methods as Methods81 } from './making-viewing-seasons-histories'
import type { Methods as Methods82 } from './modals'
import type { Methods as Methods83 } from './news'
import type { Methods as Methods84 } from './news/_newsId@string'
import type { Methods as Methods85 } from './news/_newsId@string/read'
import type { Methods as Methods86 } from './offer-wall/cv'
import type { Methods as Methods87 } from './purchased-episode-history'
import type { Methods as Methods88 } from './reactions'
import type { Methods as Methods89 } from './reactions/episodes/_episodeId@string'
import type { Methods as Methods90 } from './report-masters'
import type { Methods as Methods91 } from './reports'
import type { Methods as Methods92 } from './search'
import type { Methods as Methods93 } from './seasons/digests/_projectMasterId@string'
import type { Methods as Methods94 } from './seasons/order-create'
import type { Methods as Methods95 } from './topics'
import type { Methods as Methods96 } from './topics/_id@string'
import type { Methods as Methods97 } from './topics/_topicId@string/creators/list-up'
import type { Methods as Methods98 } from './topics/_topicId@string/episodes/list-up'
import type { Methods as Methods99 } from './topics/_topicId@string/season/episodes'
import type { Methods as Methods100 } from './topics/_topicId@string/seasons/list-up'
import type { Methods as Methods101 } from './topics/_topicId@string/works/list-up'
import type { Methods as Methods102 } from './user-notifications'
import type { Methods as Methods103 } from './user-season-notification'
import type { Methods as Methods104 } from './user-season-notification/seasons/_seasonId@string'
import type { Methods as Methods105 } from './user-settings/campaign-and-new-season-notifications'
import type { Methods as Methods106 } from './user-settings/comment-reply-notifications'
import type { Methods as Methods107 } from './user-settings/news-notifications'
import type { Methods as Methods108 } from './users'
import type { Methods as Methods109 } from './users/_providerName@string/_providerSub@string'
import type { Methods as Methods110 } from './users/_userName@string'
import type { Methods as Methods111 } from './users/account-inheritance/after-registration'
import type { Methods as Methods112 } from './users/account-inheritance/before-registration'
import type { Methods as Methods113 } from './users/block'
import type { Methods as Methods114 } from './users/check-name/_userName@string'
import type { Methods as Methods115 } from './users/fcm-token'
import type { Methods as Methods116 } from './users/firebaseUserId'
import type { Methods as Methods117 } from './users/inherited'
import type { Methods as Methods118 } from './users/providers'
import type { Methods as Methods119 } from './users/signup/validate'
import type { Methods as Methods120 } from './users/viewed-news'
import type { Methods as Methods121 } from './users/viewed-notifications'
import type { Methods as Methods122 } from './viewing-episode-histories/_episodeId@string'
import type { Methods as Methods123 } from './viewing-episode-histories/ranking'
import type { Methods as Methods124 } from './viewing-episode-history/_id@string'
import type { Methods as Methods125 } from './viewing-season-histories/_seasonId@string'
import type { Methods as Methods126 } from './viewing-season-histories/ranking'
import type { Methods as Methods127 } from './viewing-season-history/_id@string'
import type { Methods as Methods128 } from './viewing-work-histories/_workId@string'
import type { Methods as Methods129 } from './viewing-work-histories/ranking'
import type { Methods as Methods130 } from './viewing-work-history/_id@string'
import type { Methods as Methods131 } from './web/episodes/_episodeId@string'
import type { Methods as Methods132 } from './works/_workId@string'
import type { Methods as Methods133 } from './works/_workId@string/recovery-time'
import type { Methods as Methods134 } from './works/order-create'

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '/api/v1' : baseURL).replace(
    /\/$/,
    ''
  )
  const PATH0 = '/admin/categories'
  const PATH1 = '/admin/categories-localizations'
  const PATH2 = '/admin/comments'
  const PATH3 = '/admin/comments/ban'
  const PATH4 = '/admin/creator-categories'
  const PATH5 = '/admin/creator-categories-localizations'
  const PATH6 = '/admin/creator-job-localizations'
  const PATH7 = '/admin/creators'
  const PATH8 = '/admin/display-formats-master'
  const PATH9 = '/admin/episodes'
  const PATH10 = '/admin/jobs'
  const PATH11 = '/admin/list-patterns-master'
  const PATH12 = '/admin/modals'
  const PATH13 = '/admin/modals/display_order'
  const PATH14 = '/admin/news'
  const PATH15 = '/admin/news/push-notifications'
  const PATH16 = '/admin/notification-histories'
  const PATH17 = '/admin/notifications/send'
  const PATH18 = '/admin/seasons'
  const PATH19 = '/admin/topics'
  const PATH20 = '/admin/topics/display_order'
  const PATH21 = '/admin/transitions-master'
  const PATH22 = '/admin/unnotified-items'
  const PATH23 = '/admin/user-notifications/test'
  const PATH24 = '/admin/users'
  const PATH25 = '/admin/users/ban'
  const PATH26 = '/admin/works'
  const PATH27 = '/avatars'
  const PATH28 = '/banners'
  const PATH29 = '/billing-items'
  const PATH30 = '/campaigns'
  const PATH31 = '/campaigns/active'
  const PATH32 = '/coin/purchase'
  const PATH33 = '/comments'
  const PATH34 = '/comments/episodes'
  const PATH35 = '/comments/seasons'
  const PATH36 = '/commercial/available-counts'
  const PATH37 = '/contacts'
  const PATH38 = '/creators'
  const PATH39 = '/support'
  const PATH40 = '/episodes'
  const PATH41 = '/use-commercial'
  const PATH42 = '/use-free-ticket'
  const PATH43 = '/episodes/order-create'
  const PATH44 = '/episodes/purchased'
  const PATH45 = '/episodes/purchased/bulk'
  const PATH46 = '/episodes/seasons'
  const PATH47 = '/episodes/viewing-histories'
  const PATH48 = '/favorite-episodes'
  const PATH49 = '/favorite-episodes/episodes'
  const PATH50 = '/favorite-seasons'
  const PATH51 = '/favorite-seasons/seasons'
  const PATH52 = '/get-coin-history'
  const PATH53 = '/goods'
  const PATH54 = '/goods/comments'
  const PATH55 = '/health-check'
  const PATH56 = '/holding-coin'
  const PATH57 = '/invite'
  const PATH58 = '/main-favorite-episodes'
  const PATH59 = '/main-favorite-seasons'
  const PATH60 = '/main-viewing-episodes-histories'
  const PATH61 = '/main-viewing-seasons-histories'
  const PATH62 = '/making-favorite-episodes'
  const PATH63 = '/making-favorite-seasons'
  const PATH64 = '/making-viewing-episodes-histories'
  const PATH65 = '/making-viewing-seasons-histories'
  const PATH66 = '/modals'
  const PATH67 = '/news'
  const PATH68 = '/read'
  const PATH69 = '/offer-wall/cv'
  const PATH70 = '/purchased-episode-history'
  const PATH71 = '/reactions'
  const PATH72 = '/reactions/episodes'
  const PATH73 = '/report-masters'
  const PATH74 = '/reports'
  const PATH75 = '/search'
  const PATH76 = '/seasons/digests'
  const PATH77 = '/seasons/order-create'
  const PATH78 = '/topics'
  const PATH79 = '/creators/list-up'
  const PATH80 = '/episodes/list-up'
  const PATH81 = '/season/episodes'
  const PATH82 = '/seasons/list-up'
  const PATH83 = '/works/list-up'
  const PATH84 = '/user-notifications'
  const PATH85 = '/user-season-notification'
  const PATH86 = '/user-season-notification/seasons'
  const PATH87 = '/user-settings/campaign-and-new-season-notifications'
  const PATH88 = '/user-settings/comment-reply-notifications'
  const PATH89 = '/user-settings/news-notifications'
  const PATH90 = '/users'
  const PATH91 = '/users/account-inheritance/after-registration'
  const PATH92 = '/users/account-inheritance/before-registration'
  const PATH93 = '/users/block'
  const PATH94 = '/users/check-name'
  const PATH95 = '/users/fcm-token'
  const PATH96 = '/users/firebaseUserId'
  const PATH97 = '/users/inherited'
  const PATH98 = '/users/providers'
  const PATH99 = '/users/signup/validate'
  const PATH100 = '/users/viewed-news'
  const PATH101 = '/users/viewed-notifications'
  const PATH102 = '/viewing-episode-histories'
  const PATH103 = '/viewing-episode-histories/ranking'
  const PATH104 = '/viewing-episode-history'
  const PATH105 = '/viewing-season-histories'
  const PATH106 = '/viewing-season-histories/ranking'
  const PATH107 = '/viewing-season-history'
  const PATH108 = '/viewing-work-histories'
  const PATH109 = '/viewing-work-histories/ranking'
  const PATH110 = '/viewing-work-history'
  const PATH111 = '/web/episodes'
  const PATH112 = '/works'
  const PATH113 = '/recovery-time'
  const PATH114 = '/works/order-create'
  const GET = 'GET'
  const POST = 'POST'
  const PUT = 'PUT'
  const DELETE = 'DELETE'
  const HEAD = 'HEAD'
  const PATCH = 'PATCH'

  return {
    admin: {
      categories: {
        _categoryId: (val2: string) => {
          const prefix2 = `${PATH0}/${val2}`

          return {
            /**
             * 管理画面におけるカテゴリーの削除
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods1['delete']['resBody'],
                BasicHeaders,
                Methods1['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面におけるカテゴリーの削除
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods1['delete']['resBody'],
                BasicHeaders,
                Methods1['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        /**
         * 管理画面におけるカテゴリーの一覧取得
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods0['get']['resBody'],
            BasicHeaders,
            Methods0['get']['status']
          >(prefix, PATH0, GET, option).json(),
        /**
         * 管理画面におけるカテゴリーの一覧取得
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods0['get']['resBody'],
            BasicHeaders,
            Methods0['get']['status']
          >(prefix, PATH0, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面におけるカテゴリーの登録
         * @param option.body - カテゴリ情報
         * @returns Created
         */
        post: (option: {
          body: Methods0['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods0['post']['resBody'],
            BasicHeaders,
            Methods0['post']['status']
          >(prefix, PATH0, POST, option).json(),
        /**
         * 管理画面におけるカテゴリーの登録
         * @param option.body - カテゴリ情報
         * @returns Created
         */
        $post: (option: {
          body: Methods0['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods0['post']['resBody'],
            BasicHeaders,
            Methods0['post']['status']
          >(prefix, PATH0, POST, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH0}`,
      },
      categories_localizations: {
        /**
         * 管理画面からカテゴリー多言語を修正する
         * @param option.body - 更新データ
         */
        patch: (option: {
          body: Methods2['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods2['patch']['status']>(
            prefix,
            PATH1,
            PATCH,
            option
          ).send(),
        /**
         * 管理画面からカテゴリー多言語を修正する
         * @param option.body - 更新データ
         */
        $patch: (option: {
          body: Methods2['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods2['patch']['status']>(
            prefix,
            PATH1,
            PATCH,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH1}`,
      },
      comments: {
        ban: {
          _commentId: (val3: string) => {
            const prefix3 = `${PATH3}/${val3}`

            return {
              /**
               * 管理画面におけるコメントBAN処理
               * @returns OK
               */
              put: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods4['put']['resBody'],
                  BasicHeaders,
                  Methods4['put']['status']
                >(prefix, prefix3, PUT, option).json(),
              /**
               * 管理画面におけるコメントBAN処理
               * @returns OK
               */
              $put: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods4['put']['resBody'],
                  BasicHeaders,
                  Methods4['put']['status']
                >(prefix, prefix3, PUT, option)
                  .json()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            }
          },
        },
        /**
         * 管理画面におけるコメント一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        get: (
          option?:
            | {
                query?: Methods3['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods3['get']['resBody'],
            BasicHeaders,
            Methods3['get']['status']
          >(prefix, PATH2, GET, option).json(),
        /**
         * 管理画面におけるコメント一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        $get: (
          option?:
            | {
                query?: Methods3['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods3['get']['resBody'],
            BasicHeaders,
            Methods3['get']['status']
          >(prefix, PATH2, GET, option)
            .json()
            .then(r => r.body),
        $path: (
          option?:
            | { method?: 'get' | undefined; query: Methods3['get']['query'] }
            | undefined
        ) =>
          `${prefix}${PATH2}${
            option && option.query ? `?${dataToURLString(option.query)}` : ''
          }`,
      },
      creator_categories: {
        _categoryId: (val2: string) => {
          const prefix2 = `${PATH4}/${val2}`

          return {
            /**
             * 管理画面におけるクリエイターカテゴリーの削除
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods6['delete']['resBody'],
                BasicHeaders,
                Methods6['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面におけるクリエイターカテゴリーの削除
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods6['delete']['resBody'],
                BasicHeaders,
                Methods6['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        /**
         * 管理画面におけるクリエイターカテゴリーの一覧取得
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods5['get']['resBody'],
            BasicHeaders,
            Methods5['get']['status']
          >(prefix, PATH4, GET, option).json(),
        /**
         * 管理画面におけるクリエイターカテゴリーの一覧取得
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods5['get']['resBody'],
            BasicHeaders,
            Methods5['get']['status']
          >(prefix, PATH4, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面におけるクリエイターカテゴリーの登録
         * @param option.body - カテゴリ情報
         * @returns Created
         */
        post: (option: {
          body: Methods5['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods5['post']['resBody'],
            BasicHeaders,
            Methods5['post']['status']
          >(prefix, PATH4, POST, option).json(),
        /**
         * 管理画面におけるクリエイターカテゴリーの登録
         * @param option.body - カテゴリ情報
         * @returns Created
         */
        $post: (option: {
          body: Methods5['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods5['post']['resBody'],
            BasicHeaders,
            Methods5['post']['status']
          >(prefix, PATH4, POST, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH4}`,
      },
      creator_categories_localizations: {
        /**
         * 管理画面からクリエイターカテゴリー多言語を修正する
         * @param option.body - 更新データ
         */
        patch: (option: {
          body: Methods7['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods7['patch']['status']>(
            prefix,
            PATH5,
            PATCH,
            option
          ).send(),
        /**
         * 管理画面からクリエイターカテゴリー多言語を修正する
         * @param option.body - 更新データ
         */
        $patch: (option: {
          body: Methods7['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods7['patch']['status']>(
            prefix,
            PATH5,
            PATCH,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH5}`,
      },
      creator_job_localizations: {
        /**
         * 管理画面における職業の多言語編集
         * @param option.body - 職業情報
         */
        patch: (option: {
          body: Methods8['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods8['patch']['status']>(
            prefix,
            PATH6,
            PATCH,
            option
          ).send(),
        /**
         * 管理画面における職業の多言語編集
         * @param option.body - 職業情報
         */
        $patch: (option: {
          body: Methods8['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods8['patch']['status']>(
            prefix,
            PATH6,
            PATCH,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH6}`,
      },
      creators: {
        _creatorId: (val2: string) => {
          const prefix2 = `${PATH7}/${val2}`

          return {
            /**
             * 管理画面におけるクリエイターの詳細取得
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods10['get']['resBody'],
                BasicHeaders,
                Methods10['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 管理画面におけるクリエイターの詳細取得
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods10['get']['resBody'],
                BasicHeaders,
                Methods10['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面におけるクリエイターの削除
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods10['delete']['resBody'],
                BasicHeaders,
                Methods10['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面におけるクリエイターの削除
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods10['delete']['resBody'],
                BasicHeaders,
                Methods10['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面におけるクリエイターの編集
             * @param option.body - クリエイター名
             * @returns OK
             */
            patch: (option: {
              body: Methods10['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods10['patch']['resBody'],
                BasicHeaders,
                Methods10['patch']['status']
              >(prefix, prefix2, PATCH, option).json(),
            /**
             * 管理画面におけるクリエイターの編集
             * @param option.body - クリエイター名
             * @returns OK
             */
            $patch: (option: {
              body: Methods10['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods10['patch']['resBody'],
                BasicHeaders,
                Methods10['patch']['status']
              >(prefix, prefix2, PATCH, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        /**
         * 管理画面におけるクリエイターの一覧取得
         * @returns OK
         */
        get: (
          option?:
            | {
                query?: Methods9['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods9['get']['resBody'],
            BasicHeaders,
            Methods9['get']['status']
          >(prefix, PATH7, GET, option).json(),
        /**
         * 管理画面におけるクリエイターの一覧取得
         * @returns OK
         */
        $get: (
          option?:
            | {
                query?: Methods9['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods9['get']['resBody'],
            BasicHeaders,
            Methods9['get']['status']
          >(prefix, PATH7, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面におけるクリエイターの新規追加
         * @param option.body - クリエイター情報
         * @returns Created
         */
        post: (option: {
          body: Methods9['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods9['post']['resBody'],
            BasicHeaders,
            Methods9['post']['status']
          >(prefix, PATH7, POST, option).json(),
        /**
         * 管理画面におけるクリエイターの新規追加
         * @param option.body - クリエイター情報
         * @returns Created
         */
        $post: (option: {
          body: Methods9['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods9['post']['resBody'],
            BasicHeaders,
            Methods9['post']['status']
          >(prefix, PATH7, POST, option)
            .json()
            .then(r => r.body),
        $path: (
          option?:
            | { method?: 'get' | undefined; query: Methods9['get']['query'] }
            | undefined
        ) =>
          `${prefix}${PATH7}${
            option && option.query ? `?${dataToURLString(option.query)}` : ''
          }`,
      },
      display_formats_master: {
        /**
         * 【管理画面】ディスプレイ形式を全て取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods11['get']['resBody'],
            BasicHeaders,
            Methods11['get']['status']
          >(prefix, PATH8, GET, option).json(),
        /**
         * 【管理画面】ディスプレイ形式を全て取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods11['get']['resBody'],
            BasicHeaders,
            Methods11['get']['status']
          >(prefix, PATH8, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH8}`,
      },
      episodes: {
        _workId: (val2: string) => {
          const prefix2 = `${PATH9}/${val2}`

          return {
            _seasonId: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`

              return {
                _episodeId: (val4: string) => {
                  const prefix4 = `${prefix3}/${val4}`

                  return {
                    /**
                     * 管理画面におけるエピソードの詳細取得
                     * @returns OK
                     */
                    get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<
                        Methods13['get']['resBody'],
                        BasicHeaders,
                        Methods13['get']['status']
                      >(prefix, prefix4, GET, option).json(),
                    /**
                     * 管理画面におけるエピソードの詳細取得
                     * @returns OK
                     */
                    $get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<
                        Methods13['get']['resBody'],
                        BasicHeaders,
                        Methods13['get']['status']
                      >(prefix, prefix4, GET, option)
                        .json()
                        .then(r => r.body),
                    /**
                     * 管理画面におけるエピソードの削除
                     * @returns OK
                     */
                    delete: (option?: { config?: T | undefined } | undefined) =>
                      fetch<
                        Methods13['delete']['resBody'],
                        BasicHeaders,
                        Methods13['delete']['status']
                      >(prefix, prefix4, DELETE, option).json(),
                    /**
                     * 管理画面におけるエピソードの削除
                     * @returns OK
                     */
                    $delete: (
                      option?: { config?: T | undefined } | undefined
                    ) =>
                      fetch<
                        Methods13['delete']['resBody'],
                        BasicHeaders,
                        Methods13['delete']['status']
                      >(prefix, prefix4, DELETE, option)
                        .json()
                        .then(r => r.body),
                    /**
                     * 管理画面におけるエピソードの編集
                     * @param option.body - エピソード名
                     * @returns OK
                     */
                    patch: (option: {
                      body: Methods13['patch']['reqBody']
                      config?: T | undefined
                    }) =>
                      fetch<
                        Methods13['patch']['resBody'],
                        BasicHeaders,
                        Methods13['patch']['status']
                      >(prefix, prefix4, PATCH, option).json(),
                    /**
                     * 管理画面におけるエピソードの編集
                     * @param option.body - エピソード名
                     * @returns OK
                     */
                    $patch: (option: {
                      body: Methods13['patch']['reqBody']
                      config?: T | undefined
                    }) =>
                      fetch<
                        Methods13['patch']['resBody'],
                        BasicHeaders,
                        Methods13['patch']['status']
                      >(prefix, prefix4, PATCH, option)
                        .json()
                        .then(r => r.body),
                    $path: () => `${prefix}${prefix4}`,
                  }
                },
                /**
                 * 管理画面におけるseasonIdに紐づく、エピソードの一覧の取得
                 * @returns OK
                 */
                get: (option: {
                  query: Methods12['get']['query']
                  config?: T | undefined
                }) =>
                  fetch<
                    Methods12['get']['resBody'],
                    BasicHeaders,
                    Methods12['get']['status']
                  >(prefix, prefix3, GET, option).json(),
                /**
                 * 管理画面におけるseasonIdに紐づく、エピソードの一覧の取得
                 * @returns OK
                 */
                $get: (option: {
                  query: Methods12['get']['query']
                  config?: T | undefined
                }) =>
                  fetch<
                    Methods12['get']['resBody'],
                    BasicHeaders,
                    Methods12['get']['status']
                  >(prefix, prefix3, GET, option)
                    .json()
                    .then(r => r.body),
                /**
                 * 管理画面におけるエピソードの新規追加
                 * @param option.body - シーズン情報
                 * @returns Created
                 */
                post: (option: {
                  body: Methods12['post']['reqBody']
                  config?: T | undefined
                }) =>
                  fetch<
                    Methods12['post']['resBody'],
                    BasicHeaders,
                    Methods12['post']['status']
                  >(prefix, prefix3, POST, option).json(),
                /**
                 * 管理画面におけるエピソードの新規追加
                 * @param option.body - シーズン情報
                 * @returns Created
                 */
                $post: (option: {
                  body: Methods12['post']['reqBody']
                  config?: T | undefined
                }) =>
                  fetch<
                    Methods12['post']['resBody'],
                    BasicHeaders,
                    Methods12['post']['status']
                  >(prefix, prefix3, POST, option)
                    .json()
                    .then(r => r.body),
                $path: (
                  option?:
                    | {
                        method?: 'get' | undefined
                        query: Methods12['get']['query']
                      }
                    | undefined
                ) =>
                  `${prefix}${prefix3}${
                    option && option.query
                      ? `?${dataToURLString(option.query)}`
                      : ''
                  }`,
              }
            },
          }
        },
      },
      jobs: {
        _jobId: (val2: string) => {
          const prefix2 = `${PATH10}/${val2}`

          return {
            /**
             * 管理画面における職業の削除
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods15['delete']['resBody'],
                BasicHeaders,
                Methods15['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面における職業の削除
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods15['delete']['resBody'],
                BasicHeaders,
                Methods15['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        /**
         * 管理画面における職業一覧の取得
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods14['get']['resBody'],
            BasicHeaders,
            Methods14['get']['status']
          >(prefix, PATH10, GET, option).json(),
        /**
         * 管理画面における職業一覧の取得
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods14['get']['resBody'],
            BasicHeaders,
            Methods14['get']['status']
          >(prefix, PATH10, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面における職業の登録
         * @param option.body - 職業情報
         * @returns Created
         */
        post: (option: {
          body: Methods14['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods14['post']['resBody'],
            BasicHeaders,
            Methods14['post']['status']
          >(prefix, PATH10, POST, option).json(),
        /**
         * 管理画面における職業の登録
         * @param option.body - 職業情報
         * @returns Created
         */
        $post: (option: {
          body: Methods14['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods14['post']['resBody'],
            BasicHeaders,
            Methods14['post']['status']
          >(prefix, PATH10, POST, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH10}`,
      },
      list_patterns_master: {
        /**
         * 【管理画面】リストパターンを全て取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods16['get']['resBody'],
            BasicHeaders,
            Methods16['get']['status']
          >(prefix, PATH11, GET, option).json(),
        /**
         * 【管理画面】リストパターンを全て取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods16['get']['resBody'],
            BasicHeaders,
            Methods16['get']['status']
          >(prefix, PATH11, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH11}`,
      },
      modals: {
        _id: (val2: string) => {
          const prefix2 = `${PATH12}/${val2}`

          return {
            /**
             * 【管理画面】モーダル詳細を取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods18['get']['resBody'],
                BasicHeaders,
                Methods18['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 【管理画面】モーダル詳細を取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods18['get']['resBody'],
                BasicHeaders,
                Methods18['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * 【管理画面】idを渡して、モーダルを論理削除する
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods18['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              ).send(),
            /**
             * 【管理画面】idを渡して、モーダルを論理削除する
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods18['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              )
                .send()
                .then(r => r.body),
            /**
             * 管理画面からモーダルを修正する
             * @param option.body - モーダルの情報
             * @returns OK
             */
            patch: (option: {
              body: Methods18['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods18['patch']['resBody'],
                BasicHeaders,
                Methods18['patch']['status']
              >(prefix, prefix2, PATCH, option).json(),
            /**
             * 管理画面からモーダルを修正する
             * @param option.body - モーダルの情報
             * @returns OK
             */
            $patch: (option: {
              body: Methods18['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods18['patch']['resBody'],
                BasicHeaders,
                Methods18['patch']['status']
              >(prefix, prefix2, PATCH, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        display_order: {
          /**
           * 管理画面からモーダル順番を修正する
           * @param option.body - モーダルid, order
           */
          patch: (option: {
            body: Methods19['patch']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods19['patch']['status']>(
              prefix,
              PATH13,
              PATCH,
              option
            ).send(),
          /**
           * 管理画面からモーダル順番を修正する
           * @param option.body - モーダルid, order
           */
          $patch: (option: {
            body: Methods19['patch']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods19['patch']['status']>(
              prefix,
              PATH13,
              PATCH,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${PATH13}`,
        },
        /**
         * 【管理画面】モーダルを全て取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods17['get']['resBody'],
            BasicHeaders,
            Methods17['get']['status']
          >(prefix, PATH12, GET, option).json(),
        /**
         * 【管理画面】モーダルを全て取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods17['get']['resBody'],
            BasicHeaders,
            Methods17['get']['status']
          >(prefix, PATH12, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面からモーダルを新規作成する
         * @param option.body - モーダルの情報
         * @returns Created
         */
        post: (option: {
          body: Methods17['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods17['post']['resBody'],
            BasicHeaders,
            Methods17['post']['status']
          >(prefix, PATH12, POST, option).json(),
        /**
         * 管理画面からモーダルを新規作成する
         * @param option.body - モーダルの情報
         * @returns Created
         */
        $post: (option: {
          body: Methods17['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods17['post']['resBody'],
            BasicHeaders,
            Methods17['post']['status']
          >(prefix, PATH12, POST, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH12}`,
      },
      news: {
        _newsId: (val2: string) => {
          const prefix2 = `${PATH14}/${val2}`

          return {
            /**
             * 管理画面におけるお知らせ詳細の取得
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods21['get']['resBody'],
                BasicHeaders,
                Methods21['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 管理画面におけるお知らせ詳細の取得
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods21['get']['resBody'],
                BasicHeaders,
                Methods21['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面におけるお知らせ削除
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods21['delete']['resBody'],
                BasicHeaders,
                Methods21['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面におけるお知らせ削除
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods21['delete']['resBody'],
                BasicHeaders,
                Methods21['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面におけるお知らせ編集
             * @param option.body - お知らせ情報
             * @returns OK
             */
            patch: (option: {
              body: Methods21['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods21['patch']['resBody'],
                BasicHeaders,
                Methods21['patch']['status']
              >(prefix, prefix2, PATCH, option).json(),
            /**
             * 管理画面におけるお知らせ編集
             * @param option.body - お知らせ情報
             * @returns OK
             */
            $patch: (option: {
              body: Methods21['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods21['patch']['resBody'],
                BasicHeaders,
                Methods21['patch']['status']
              >(prefix, prefix2, PATCH, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        push_notifications: {
          /**
           * newsトピックにプッシュ通知を送る
           * @param option.body - プッシュ通知情報
           */
          post: (option: {
            body: Methods22['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods22['post']['status']>(
              prefix,
              PATH15,
              POST,
              option
            ).send(),
          /**
           * newsトピックにプッシュ通知を送る
           * @param option.body - プッシュ通知情報
           */
          $post: (option: {
            body: Methods22['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods22['post']['status']>(
              prefix,
              PATH15,
              POST,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${PATH15}`,
        },
        /**
         * 管理画面におけるお知らせ一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        get: (
          option?:
            | {
                query?: Methods20['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods20['get']['resBody'],
            BasicHeaders,
            Methods20['get']['status']
          >(prefix, PATH14, GET, option).json(),
        /**
         * 管理画面におけるお知らせ一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        $get: (
          option?:
            | {
                query?: Methods20['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods20['get']['resBody'],
            BasicHeaders,
            Methods20['get']['status']
          >(prefix, PATH14, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面におけるお知らせ登録
         * @param option.body - お知らせ情報
         * @returns Created
         */
        post: (option: {
          body: Methods20['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods20['post']['resBody'],
            BasicHeaders,
            Methods20['post']['status']
          >(prefix, PATH14, POST, option).json(),
        /**
         * 管理画面におけるお知らせ登録
         * @param option.body - お知らせ情報
         * @returns Created
         */
        $post: (option: {
          body: Methods20['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods20['post']['resBody'],
            BasicHeaders,
            Methods20['post']['status']
          >(prefix, PATH14, POST, option)
            .json()
            .then(r => r.body),
        $path: (
          option?:
            | { method?: 'get' | undefined; query: Methods20['get']['query'] }
            | undefined
        ) =>
          `${prefix}${PATH14}${
            option && option.query ? `?${dataToURLString(option.query)}` : ''
          }`,
      },
      notification_histories: {
        /**
         * 管理画面における通知履歴一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        get: (
          option?:
            | {
                query?: Methods23['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods23['get']['resBody'],
            BasicHeaders,
            Methods23['get']['status']
          >(prefix, PATH16, GET, option).json(),
        /**
         * 管理画面における通知履歴一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        $get: (
          option?:
            | {
                query?: Methods23['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods23['get']['resBody'],
            BasicHeaders,
            Methods23['get']['status']
          >(prefix, PATH16, GET, option)
            .json()
            .then(r => r.body),
        $path: (
          option?:
            | { method?: 'get' | undefined; query: Methods23['get']['query'] }
            | undefined
        ) =>
          `${prefix}${PATH16}${
            option && option.query ? `?${dataToURLString(option.query)}` : ''
          }`,
      },
      notifications: {
        send: {
          /**
           * 通知
           * @param option.body - 通知の種類(seasons, episodes, news, campaigns)
           * @returns Created
           */
          post: (option: {
            body: Methods24['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods24['post']['resBody'],
              BasicHeaders,
              Methods24['post']['status']
            >(prefix, PATH17, POST, option).json(),
          /**
           * 通知
           * @param option.body - 通知の種類(seasons, episodes, news, campaigns)
           * @returns Created
           */
          $post: (option: {
            body: Methods24['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods24['post']['resBody'],
              BasicHeaders,
              Methods24['post']['status']
            >(prefix, PATH17, POST, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${PATH17}`,
        },
      },
      seasons: {
        _workId: (val2: string) => {
          const prefix2 = `${PATH18}/${val2}`

          return {
            _seasonId: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`

              return {
                /**
                 * 管理画面におけるシーズンの詳細取得
                 * @returns OK
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<
                    Methods27['get']['resBody'],
                    BasicHeaders,
                    Methods27['get']['status']
                  >(prefix, prefix3, GET, option).json(),
                /**
                 * 管理画面におけるシーズンの詳細取得
                 * @returns OK
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<
                    Methods27['get']['resBody'],
                    BasicHeaders,
                    Methods27['get']['status']
                  >(prefix, prefix3, GET, option)
                    .json()
                    .then(r => r.body),
                /**
                 * 管理画面におけるシーズンの削除
                 * @returns OK
                 */
                delete: (option?: { config?: T | undefined } | undefined) =>
                  fetch<
                    Methods27['delete']['resBody'],
                    BasicHeaders,
                    Methods27['delete']['status']
                  >(prefix, prefix3, DELETE, option).json(),
                /**
                 * 管理画面におけるシーズンの削除
                 * @returns OK
                 */
                $delete: (option?: { config?: T | undefined } | undefined) =>
                  fetch<
                    Methods27['delete']['resBody'],
                    BasicHeaders,
                    Methods27['delete']['status']
                  >(prefix, prefix3, DELETE, option)
                    .json()
                    .then(r => r.body),
                /**
                 * 管理画面におけるシーズンの編集
                 * @param option.body - 作品名
                 * @returns OK
                 */
                patch: (option: {
                  body: Methods27['patch']['reqBody']
                  config?: T | undefined
                }) =>
                  fetch<
                    Methods27['patch']['resBody'],
                    BasicHeaders,
                    Methods27['patch']['status']
                  >(prefix, prefix3, PATCH, option).json(),
                /**
                 * 管理画面におけるシーズンの編集
                 * @param option.body - 作品名
                 * @returns OK
                 */
                $patch: (option: {
                  body: Methods27['patch']['reqBody']
                  config?: T | undefined
                }) =>
                  fetch<
                    Methods27['patch']['resBody'],
                    BasicHeaders,
                    Methods27['patch']['status']
                  >(prefix, prefix3, PATCH, option)
                    .json()
                    .then(r => r.body),
                $path: () => `${prefix}${prefix3}`,
              }
            },
            /**
             * 管理画面におけるworkIdに紐づく、シーズンの一覧の取得
             * @returns OK
             */
            get: (option: {
              query: Methods26['get']['query']
              config?: T | undefined
            }) =>
              fetch<
                Methods26['get']['resBody'],
                BasicHeaders,
                Methods26['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 管理画面におけるworkIdに紐づく、シーズンの一覧の取得
             * @returns OK
             */
            $get: (option: {
              query: Methods26['get']['query']
              config?: T | undefined
            }) =>
              fetch<
                Methods26['get']['resBody'],
                BasicHeaders,
                Methods26['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面におけるシーズンの新規追加
             * @param option.body - シーズン情報
             * @returns Created
             */
            post: (option: {
              body: Methods26['post']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods26['post']['resBody'],
                BasicHeaders,
                Methods26['post']['status']
              >(prefix, prefix2, POST, option).json(),
            /**
             * 管理画面におけるシーズンの新規追加
             * @param option.body - シーズン情報
             * @returns Created
             */
            $post: (option: {
              body: Methods26['post']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods26['post']['resBody'],
                BasicHeaders,
                Methods26['post']['status']
              >(prefix, prefix2, POST, option)
                .json()
                .then(r => r.body),
            $path: (
              option?:
                | {
                    method?: 'get' | undefined
                    query: Methods26['get']['query']
                  }
                | undefined
            ) =>
              `${prefix}${prefix2}${
                option && option.query
                  ? `?${dataToURLString(option.query)}`
                  : ''
              }`,
          }
        },
        /**
         * 全てのシーズンの取得
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods25['get']['resBody'],
            BasicHeaders,
            Methods25['get']['status']
          >(prefix, PATH18, GET, option).json(),
        /**
         * 全てのシーズンの取得
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods25['get']['resBody'],
            BasicHeaders,
            Methods25['get']['status']
          >(prefix, PATH18, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH18}`,
      },
      topics: {
        _id: (val2: string) => {
          const prefix2 = `${PATH19}/${val2}`

          return {
            /**
             * 【管理画面】トピックス詳細を取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods29['get']['resBody'],
                BasicHeaders,
                Methods29['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 【管理画面】トピックス詳細を取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods29['get']['resBody'],
                BasicHeaders,
                Methods29['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * 【管理画面】idを渡して、トピックスを論理削除する
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods29['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              ).send(),
            /**
             * 【管理画面】idを渡して、トピックスを論理削除する
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods29['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              )
                .send()
                .then(r => r.body),
            /**
             * 管理画面からトピックを修正する
             * @param option.body - トピックの情報
             * @returns OK
             */
            patch: (option: {
              body: Methods29['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods29['patch']['resBody'],
                BasicHeaders,
                Methods29['patch']['status']
              >(prefix, prefix2, PATCH, option).json(),
            /**
             * 管理画面からトピックを修正する
             * @param option.body - トピックの情報
             * @returns OK
             */
            $patch: (option: {
              body: Methods29['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods29['patch']['resBody'],
                BasicHeaders,
                Methods29['patch']['status']
              >(prefix, prefix2, PATCH, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        display_order: {
          /**
           * 管理画面からトピック順番を修正する
           * @param option.body - トピックid, order
           */
          patch: (option: {
            body: Methods30['patch']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods30['patch']['status']>(
              prefix,
              PATH20,
              PATCH,
              option
            ).send(),
          /**
           * 管理画面からトピック順番を修正する
           * @param option.body - トピックid, order
           */
          $patch: (option: {
            body: Methods30['patch']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods30['patch']['status']>(
              prefix,
              PATH20,
              PATCH,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${PATH20}`,
        },
        /**
         * 【管理画面】トピックスを全て取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods28['get']['resBody'],
            BasicHeaders,
            Methods28['get']['status']
          >(prefix, PATH19, GET, option).json(),
        /**
         * 【管理画面】トピックスを全て取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods28['get']['resBody'],
            BasicHeaders,
            Methods28['get']['status']
          >(prefix, PATH19, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面からトピックを新規作成する
         * @param option.body - トピックの情報
         * @returns Created
         */
        post: (option: {
          body: Methods28['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods28['post']['resBody'],
            BasicHeaders,
            Methods28['post']['status']
          >(prefix, PATH19, POST, option).json(),
        /**
         * 管理画面からトピックを新規作成する
         * @param option.body - トピックの情報
         * @returns Created
         */
        $post: (option: {
          body: Methods28['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods28['post']['resBody'],
            BasicHeaders,
            Methods28['post']['status']
          >(prefix, PATH19, POST, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH19}`,
      },
      transitions_master: {
        /**
         * 【管理画面】遷移先を全て取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods31['get']['resBody'],
            BasicHeaders,
            Methods31['get']['status']
          >(prefix, PATH21, GET, option).json(),
        /**
         * 【管理画面】遷移先を全て取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods31['get']['resBody'],
            BasicHeaders,
            Methods31['get']['status']
          >(prefix, PATH21, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH21}`,
      },
      unnotified_items: {
        _notificationType: (val2: string) => {
          const prefix2 = `${PATH22}/${val2}`

          return {
            /**
             * 管理画面における通知TYPEに紐づく、未通知アイテム一覧の取得
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods32['get']['resBody'],
                BasicHeaders,
                Methods32['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 管理画面における通知TYPEに紐づく、未通知アイテム一覧の取得
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods32['get']['resBody'],
                BasicHeaders,
                Methods32['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      user_notifications: {
        test: {
          /**
           * 通知テスト
           * @param option.body - テスト通知の中身
           * @returns Created
           */
          post: (option: {
            body: Methods33['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods33['post']['resBody'],
              BasicHeaders,
              Methods33['post']['status']
            >(prefix, PATH23, POST, option).json(),
          /**
           * 通知テスト
           * @param option.body - テスト通知の中身
           * @returns Created
           */
          $post: (option: {
            body: Methods33['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods33['post']['resBody'],
              BasicHeaders,
              Methods33['post']['status']
            >(prefix, PATH23, POST, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${PATH23}`,
        },
      },
      users: {
        _userId: (val2: string) => {
          const prefix2 = `${PATH24}/${val2}`

          return {
            /**
             * 管理画面におけるユーザー削除処理
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods35['delete']['resBody'],
                BasicHeaders,
                Methods35['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面におけるユーザー削除処理
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods35['delete']['resBody'],
                BasicHeaders,
                Methods35['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        ban: {
          _userId: (val3: string) => {
            const prefix3 = `${PATH25}/${val3}`

            return {
              /**
               * 管理画面におけるユーザーBAN処理
               * @returns OK
               */
              put: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods36['put']['resBody'],
                  BasicHeaders,
                  Methods36['put']['status']
                >(prefix, prefix3, PUT, option).json(),
              /**
               * 管理画面におけるユーザーBAN処理
               * @returns OK
               */
              $put: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods36['put']['resBody'],
                  BasicHeaders,
                  Methods36['put']['status']
                >(prefix, prefix3, PUT, option)
                  .json()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            }
          },
        },
        /**
         * 管理画面におけるユーザー一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        get: (
          option?:
            | {
                query?: Methods34['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods34['get']['resBody'],
            BasicHeaders,
            Methods34['get']['status']
          >(prefix, PATH24, GET, option).json(),
        /**
         * 管理画面におけるユーザー一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        $get: (
          option?:
            | {
                query?: Methods34['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods34['get']['resBody'],
            BasicHeaders,
            Methods34['get']['status']
          >(prefix, PATH24, GET, option)
            .json()
            .then(r => r.body),
        $path: (
          option?:
            | { method?: 'get' | undefined; query: Methods34['get']['query'] }
            | undefined
        ) =>
          `${prefix}${PATH24}${
            option && option.query ? `?${dataToURLString(option.query)}` : ''
          }`,
      },
      works: {
        _workId: (val2: string) => {
          const prefix2 = `${PATH26}/${val2}`

          return {
            /**
             * 管理画面における作品の詳細取得
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods38['get']['resBody'],
                BasicHeaders,
                Methods38['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 管理画面における作品の詳細取得
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods38['get']['resBody'],
                BasicHeaders,
                Methods38['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面における作品の削除
             * @returns OK
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods38['delete']['resBody'],
                BasicHeaders,
                Methods38['delete']['status']
              >(prefix, prefix2, DELETE, option).json(),
            /**
             * 管理画面における作品の削除
             * @returns OK
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods38['delete']['resBody'],
                BasicHeaders,
                Methods38['delete']['status']
              >(prefix, prefix2, DELETE, option)
                .json()
                .then(r => r.body),
            /**
             * 管理画面における作品の編集
             * @param option.body - 作品名
             * @returns OK
             */
            patch: (option: {
              body: Methods38['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods38['patch']['resBody'],
                BasicHeaders,
                Methods38['patch']['status']
              >(prefix, prefix2, PATCH, option).json(),
            /**
             * 管理画面における作品の編集
             * @param option.body - 作品名
             * @returns OK
             */
            $patch: (option: {
              body: Methods38['patch']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods38['patch']['resBody'],
                BasicHeaders,
                Methods38['patch']['status']
              >(prefix, prefix2, PATCH, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        /**
         * 管理画面における作品一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        get: (
          option?:
            | {
                query?: Methods37['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods37['get']['resBody'],
            BasicHeaders,
            Methods37['get']['status']
          >(prefix, PATH26, GET, option).json(),
        /**
         * 管理画面における作品一覧の取得（デフォルトで20件表示）
         * @returns OK
         */
        $get: (
          option?:
            | {
                query?: Methods37['get']['query'] | undefined
                config?: T | undefined
              }
            | undefined
        ) =>
          fetch<
            Methods37['get']['resBody'],
            BasicHeaders,
            Methods37['get']['status']
          >(prefix, PATH26, GET, option)
            .json()
            .then(r => r.body),
        /**
         * 管理画面における作品の新規追加
         * @param option.body - 作品名
         * @returns Created
         */
        post: (option: {
          body: Methods37['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods37['post']['resBody'],
            BasicHeaders,
            Methods37['post']['status']
          >(prefix, PATH26, POST, option).json(),
        /**
         * 管理画面における作品の新規追加
         * @param option.body - 作品名
         * @returns Created
         */
        $post: (option: {
          body: Methods37['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods37['post']['resBody'],
            BasicHeaders,
            Methods37['post']['status']
          >(prefix, PATH26, POST, option)
            .json()
            .then(r => r.body),
        $path: (
          option?:
            | { method?: 'get' | undefined; query: Methods37['get']['query'] }
            | undefined
        ) =>
          `${prefix}${PATH26}${
            option && option.query ? `?${dataToURLString(option.query)}` : ''
          }`,
      },
    },
    avatars: {
      /**
       * アバター一覧の取得
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods39['get']['resBody'],
          BasicHeaders,
          Methods39['get']['status']
        >(prefix, PATH27, GET, option).json(),
      /**
       * アバター一覧の取得
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods39['get']['resBody'],
          BasicHeaders,
          Methods39['get']['status']
        >(prefix, PATH27, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH27}`,
    },
    banners: {
      _id: (val1: string) => {
        const prefix1 = `${PATH28}/${val1}`

        return {
          /**
           * 受け取ったtopicIDに紐づく、バナーを取得する
           * @returns OK
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods40['get']['resBody'],
              BasicHeaders,
              Methods40['get']['status']
            >(prefix, prefix1, GET, option).json(),
          /**
           * 受け取ったtopicIDに紐づく、バナーを取得する
           * @returns OK
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods40['get']['resBody'],
              BasicHeaders,
              Methods40['get']['status']
            >(prefix, prefix1, GET, option)
              .json()
              .then(r => r.body),
          /**
           * idを渡して、バナーを論理削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods40['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * idを渡して、バナーを論理削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods40['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
    },
    billing_items: {
      /**
       * 購入できるコインのリストを取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods41['get']['resBody'],
          BasicHeaders,
          Methods41['get']['status']
        >(prefix, PATH29, GET, option).json(),
      /**
       * 購入できるコインのリストを取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods41['get']['resBody'],
          BasicHeaders,
          Methods41['get']['status']
        >(prefix, PATH29, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH29}`,
    },
    campaigns: {
      _campaignId: (val1: string) => {
        const prefix1 = `${PATH30}/${val1}`

        return {
          /**
           * キャンペーン通知詳細取得
           * @returns OK
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods42['get']['resBody'],
              BasicHeaders,
              Methods42['get']['status']
            >(prefix, prefix1, GET, option).json(),
          /**
           * キャンペーン通知詳細取得
           * @returns OK
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods42['get']['resBody'],
              BasicHeaders,
              Methods42['get']['status']
            >(prefix, prefix1, GET, option)
              .json()
              .then(r => r.body),
          /**
           * キャンペーンを完了して報酬を受け取る
           * @returns OK
           */
          post: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods42['post']['resBody'],
              BasicHeaders,
              Methods42['post']['status']
            >(prefix, prefix1, POST, option).json(),
          /**
           * キャンペーンを完了して報酬を受け取る
           * @returns OK
           */
          $post: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods42['post']['resBody'],
              BasicHeaders,
              Methods42['post']['status']
            >(prefix, prefix1, POST, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      active: {
        /**
         * 現在有効なキャンペーン情報を取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods43['get']['resBody'],
            BasicHeaders,
            Methods43['get']['status']
          >(prefix, PATH31, GET, option).json(),
        /**
         * 現在有効なキャンペーン情報を取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods43['get']['resBody'],
            BasicHeaders,
            Methods43['get']['status']
          >(prefix, PATH31, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH31}`,
      },
    },
    coin: {
      purchase: {
        /**
         * コインを購入する
         * @param option.body - コイン購入
         */
        post: (option: {
          body: Methods44['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods44['post']['status']>(
            prefix,
            PATH32,
            POST,
            option
          ).send(),
        /**
         * コインを購入する
         * @param option.body - コイン購入
         */
        $post: (option: {
          body: Methods44['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods44['post']['status']>(
            prefix,
            PATH32,
            POST,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH32}`,
      },
    },
    comments: {
      episodes: {
        _episodeId: (val2: string) => {
          const prefix2 = `${PATH34}/${val2}`

          return {
            /**
             * 特定エピソードの返信を含むコメント、いいね数を取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods46['get']['resBody'],
                BasicHeaders,
                Methods46['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 特定エピソードの返信を含むコメント、いいね数を取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods46['get']['resBody'],
                BasicHeaders,
                Methods46['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      seasons: {
        _projectMasterId: (val2: string) => {
          const prefix2 = `${PATH35}/${val2}`

          return {
            _seasonId: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`

              return {
                /**
                 * 特定のシーズンに紐づく全てのエピソードのコメントを取得する
                 * @returns OK
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<
                    Methods47['get']['resBody'],
                    BasicHeaders,
                    Methods47['get']['status']
                  >(prefix, prefix3, GET, option).json(),
                /**
                 * 特定のシーズンに紐づく全てのエピソードのコメントを取得する
                 * @returns OK
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<
                    Methods47['get']['resBody'],
                    BasicHeaders,
                    Methods47['get']['status']
                  >(prefix, prefix3, GET, option)
                    .json()
                    .then(r => r.body),
                $path: () => `${prefix}${prefix3}`,
              }
            },
          }
        },
      },
      /**
       * 特定コメントに対してスパム報告
       * @param option.body - 対象のコメント
       * @returns Created
       */
      put: (option: {
        body: Methods45['put']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods45['put']['resBody'],
          BasicHeaders,
          Methods45['put']['status']
        >(prefix, PATH33, PUT, option).json(),
      /**
       * 特定コメントに対してスパム報告
       * @param option.body - 対象のコメント
       * @returns Created
       */
      $put: (option: {
        body: Methods45['put']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods45['put']['resBody'],
          BasicHeaders,
          Methods45['put']['status']
        >(prefix, PATH33, PUT, option)
          .json()
          .then(r => r.body),
      /**
       * 特定のエピソードに対して、コメントの投稿もしくはコメントに対しての返信
       * @param option.body - コメント
       * @returns Created
       */
      post: (option: {
        body: Methods45['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods45['post']['resBody'],
          BasicHeaders,
          Methods45['post']['status']
        >(prefix, PATH33, POST, option).json(),
      /**
       * 特定のエピソードに対して、コメントの投稿もしくはコメントに対しての返信
       * @param option.body - コメント
       * @returns Created
       */
      $post: (option: {
        body: Methods45['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods45['post']['resBody'],
          BasicHeaders,
          Methods45['post']['status']
        >(prefix, PATH33, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH33}`,
    },
    commercial: {
      available_counts: {
        /**
         * 動画(広告)で無料を使える回数を取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods48['get']['resBody'],
            BasicHeaders,
            Methods48['get']['status']
          >(prefix, PATH36, GET, option).json(),
        /**
         * 動画(広告)で無料を使える回数を取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods48['get']['resBody'],
            BasicHeaders,
            Methods48['get']['status']
          >(prefix, PATH36, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH36}`,
      },
    },
    contacts: {
      /**
       * お問い合わせの送信
       * @param option.body - お問い合わせ
       * @returns Created
       */
      post: (option: {
        body: Methods49['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods49['post']['resBody'],
          BasicHeaders,
          Methods49['post']['status']
        >(prefix, PATH37, POST, option).json(),
      /**
       * お問い合わせの送信
       * @param option.body - お問い合わせ
       * @returns Created
       */
      $post: (option: {
        body: Methods49['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods49['post']['resBody'],
          BasicHeaders,
          Methods49['post']['status']
        >(prefix, PATH37, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH37}`,
    },
    creators: {
      _creatorId: (val1: string) => {
        const prefix1 = `${PATH38}/${val1}`

        return {
          support: {
            /**
             * クリエイター支援
             * @param option.body - 支援内容
             * @returns OK
             */
            post: (option: {
              body: Methods52['post']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods52['post']['resBody'],
                BasicHeaders,
                Methods52['post']['status']
              >(prefix, `${prefix1}${PATH39}`, POST, option).json(),
            /**
             * クリエイター支援
             * @param option.body - 支援内容
             * @returns OK
             */
            $post: (option: {
              body: Methods52['post']['reqBody']
              config?: T | undefined
            }) =>
              fetch<
                Methods52['post']['resBody'],
                BasicHeaders,
                Methods52['post']['status']
              >(prefix, `${prefix1}${PATH39}`, POST, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH39}`,
          },
          /**
           * クリエイター詳細の取得
           * @returns OK
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods51['get']['resBody'],
              BasicHeaders,
              Methods51['get']['status']
            >(prefix, prefix1, GET, option).json(),
          /**
           * クリエイター詳細の取得
           * @returns OK
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods51['get']['resBody'],
              BasicHeaders,
              Methods51['get']['status']
            >(prefix, prefix1, GET, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      /**
       * creatorsテーブルから、クリエイターを全て取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods50['get']['resBody'],
          BasicHeaders,
          Methods50['get']['status']
        >(prefix, PATH38, GET, option).json(),
      /**
       * creatorsテーブルから、クリエイターを全て取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods50['get']['resBody'],
          BasicHeaders,
          Methods50['get']['status']
        >(prefix, PATH38, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH38}`,
    },
    episodes: {
      _episodeId: (val1: string) => {
        const prefix1 = `${PATH40}/${val1}`

        return {
          use_commercial: {
            /**
             * episodeIDを渡すことで、コマーシャルの閲覧によってエピソードURLの取得
             * @returns OK
             */
            post: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods54['post']['resBody'],
                BasicHeaders,
                Methods54['post']['status']
              >(prefix, `${prefix1}${PATH41}`, POST, option).json(),
            /**
             * episodeIDを渡すことで、コマーシャルの閲覧によってエピソードURLの取得
             * @returns OK
             */
            $post: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods54['post']['resBody'],
                BasicHeaders,
                Methods54['post']['status']
              >(prefix, `${prefix1}${PATH41}`, POST, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH41}`,
          },
          use_free_ticket: {
            /**
             * episodeIDを渡すことで、無料チケットを使ってエピソードURLの取得
             * @returns OK
             */
            post: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods55['post']['resBody'],
                BasicHeaders,
                Methods55['post']['status']
              >(prefix, `${prefix1}${PATH42}`, POST, option).json(),
            /**
             * episodeIDを渡すことで、無料チケットを使ってエピソードURLの取得
             * @returns OK
             */
            $post: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods55['post']['resBody'],
                BasicHeaders,
                Methods55['post']['status']
              >(prefix, `${prefix1}${PATH42}`, POST, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH42}`,
          },
          /**
           * episodeIDを渡すことで、エピソード詳細の取得
           * @returns OK
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods53['get']['resBody'],
              BasicHeaders,
              Methods53['get']['status']
            >(prefix, prefix1, GET, option).json(),
          /**
           * episodeIDを渡すことで、エピソード詳細の取得
           * @returns OK
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods53['get']['resBody'],
              BasicHeaders,
              Methods53['get']['status']
            >(prefix, prefix1, GET, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      order_create: {
        /**
         * エピソードを新着順に取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods56['get']['resBody'],
            BasicHeaders,
            Methods56['get']['status']
          >(prefix, PATH43, GET, option).json(),
        /**
         * エピソードを新着順に取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods56['get']['resBody'],
            BasicHeaders,
            Methods56['get']['status']
          >(prefix, PATH43, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH43}`,
      },
      purchased: {
        _projectMasterId: (val2: string) => {
          const prefix2 = `${PATH44}/${val2}`

          return {
            /**
             * 購入済みのエピソードを取得し、その際にシーズンの情報も取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods58['get']['resBody'],
                BasicHeaders,
                Methods58['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 購入済みのエピソードを取得し、その際にシーズンの情報も取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods58['get']['resBody'],
                BasicHeaders,
                Methods58['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
        bulk: {
          /**
           * コイン消費によるまとめてエピソード購入
           * @param option.body - 登録データ
           */
          post: (option: {
            body: Methods59['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods59['post']['status']>(
              prefix,
              PATH45,
              POST,
              option
            ).send(),
          /**
           * コイン消費によるまとめてエピソード購入
           * @param option.body - 登録データ
           */
          $post: (option: {
            body: Methods59['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods59['post']['status']>(
              prefix,
              PATH45,
              POST,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${PATH45}`,
        },
        /**
         * コイン消費によるエピソード購入
         * @param option.body - 登録データ
         */
        post: (option: {
          body: Methods57['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods57['post']['status']>(
            prefix,
            PATH44,
            POST,
            option
          ).send(),
        /**
         * コイン消費によるエピソード購入
         * @param option.body - 登録データ
         */
        $post: (option: {
          body: Methods57['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<void, BasicHeaders, Methods57['post']['status']>(
            prefix,
            PATH44,
            POST,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH44}`,
      },
      seasons: {
        _seasonId: (val2: string) => {
          const prefix2 = `${PATH46}/${val2}`

          return {
            /**
             * 作品IDに紐づくエピソードを取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods60['get']['resBody'],
                BasicHeaders,
                Methods60['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * 作品IDに紐づくエピソードを取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods60['get']['resBody'],
                BasicHeaders,
                Methods60['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      viewing_histories: {
        /**
         * 視聴履歴があるエピソードのseason_idに紐づくシーズンの新着エピソードを取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods61['get']['resBody'],
            BasicHeaders,
            Methods61['get']['status']
          >(prefix, PATH47, GET, option).json(),
        /**
         * 視聴履歴があるエピソードのseason_idに紐づくシーズンの新着エピソードを取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods61['get']['resBody'],
            BasicHeaders,
            Methods61['get']['status']
          >(prefix, PATH47, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH47}`,
      },
    },
    favorite_episodes: {
      _id: (val1: string) => {
        const prefix1 = `${PATH48}/${val1}`

        return {
          /**
           * IDを渡して、お気に入りエピソードを削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods63['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * IDを渡して、お気に入りエピソードを削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods63['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      episodes: {
        _episodeId: (val2: string) => {
          const prefix2 = `${PATH49}/${val2}`

          return {
            /**
             * episodeIDとuserIDを渡して、お気に入りエピソードを削除する
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods64['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              ).send(),
            /**
             * episodeIDとuserIDを渡して、お気に入りエピソードを削除する
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods64['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              )
                .send()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      /**
       * お気に入りエピソードを追加
       * @param option.body - 登録データ
       * @returns Created
       */
      post: (option: {
        body: Methods62['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods62['post']['resBody'],
          BasicHeaders,
          Methods62['post']['status']
        >(prefix, PATH48, POST, option).json(),
      /**
       * お気に入りエピソードを追加
       * @param option.body - 登録データ
       * @returns Created
       */
      $post: (option: {
        body: Methods62['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods62['post']['resBody'],
          BasicHeaders,
          Methods62['post']['status']
        >(prefix, PATH48, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH48}`,
    },
    favorite_seasons: {
      _id: (val1: string) => {
        const prefix1 = `${PATH50}/${val1}`

        return {
          /**
           * IDを渡して、お気に入りシーズンを削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods66['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * IDを渡して、お気に入りシーズンを削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods66['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      seasons: {
        _seasonId: (val2: string) => {
          const prefix2 = `${PATH51}/${val2}`

          return {
            /**
             * userIDとseasonIDを渡し、お気に入りのシーズンを取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods67['get']['resBody'],
                BasicHeaders,
                Methods67['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * userIDとseasonIDを渡し、お気に入りのシーズンを取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods67['get']['resBody'],
                BasicHeaders,
                Methods67['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            /**
             * seasonIDとuserIDを渡して、お気に入りシーズンを削除する
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods67['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              ).send(),
            /**
             * seasonIDとuserIDを渡して、お気に入りシーズンを削除する
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods67['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              )
                .send()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      /**
       * お気に入りシーズンを追加
       * @param option.body - 登録データ
       * @returns Created
       */
      post: (option: {
        body: Methods65['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods65['post']['resBody'],
          BasicHeaders,
          Methods65['post']['status']
        >(prefix, PATH50, POST, option).json(),
      /**
       * お気に入りシーズンを追加
       * @param option.body - 登録データ
       * @returns Created
       */
      $post: (option: {
        body: Methods65['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods65['post']['resBody'],
          BasicHeaders,
          Methods65['post']['status']
        >(prefix, PATH50, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH50}`,
    },
    get_coin_history: {
      /**
       * コインの取得履歴(UUID、取得量、取得日時、取得方法)を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods68['get']['resBody'],
          BasicHeaders,
          Methods68['get']['status']
        >(prefix, PATH52, GET, option).json(),
      /**
       * コインの取得履歴(UUID、取得量、取得日時、取得方法)を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods68['get']['resBody'],
          BasicHeaders,
          Methods68['get']['status']
        >(prefix, PATH52, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH52}`,
    },
    goods: {
      comments: {
        _commentId: (val2: string) => {
          const prefix2 = `${PATH54}/${val2}`

          return {
            /**
             * commentIDを渡して、いいねを削除する(userIdは内部で取得する)
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods70['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              ).send(),
            /**
             * commentIDを渡して、いいねを削除する(userIdは内部で取得する)
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods70['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              )
                .send()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      /**
       * commentIDを渡して、いいねをする(userIdは内部で取得する)
       * @param option.body - コメントのUUID
       * @returns Created
       */
      post: (option: {
        body: Methods69['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods69['post']['resBody'],
          BasicHeaders,
          Methods69['post']['status']
        >(prefix, PATH53, POST, option).json(),
      /**
       * commentIDを渡して、いいねをする(userIdは内部で取得する)
       * @param option.body - コメントのUUID
       * @returns Created
       */
      $post: (option: {
        body: Methods69['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods69['post']['resBody'],
          BasicHeaders,
          Methods69['post']['status']
        >(prefix, PATH53, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH53}`,
    },
    health_check: {
      /**
       * ヘルスチェック
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods71['get']['resBody'],
          BasicHeaders,
          Methods71['get']['status']
        >(prefix, PATH55, GET, option).text(),
      /**
       * ヘルスチェック
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods71['get']['resBody'],
          BasicHeaders,
          Methods71['get']['status']
        >(prefix, PATH55, GET, option)
          .text()
          .then(r => r.body),
      $path: () => `${prefix}${PATH55}`,
    },
    holding_coin: {
      /**
       * 購入枚数の合計と支払ったコインの合計の差分より、所有コインの枚数を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods72['get']['resBody'],
          BasicHeaders,
          Methods72['get']['status']
        >(prefix, PATH56, GET, option).json(),
      /**
       * 購入枚数の合計と支払ったコインの合計の差分より、所有コインの枚数を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods72['get']['resBody'],
          BasicHeaders,
          Methods72['get']['status']
        >(prefix, PATH56, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH56}`,
    },
    invite: {
      /**
       * 招待コードを渡し、招待してくれたユーザーを登録する
       * @param option.body - 招待コード
       * @returns Created
       */
      post: (option: {
        body: Methods73['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods73['post']['resBody'],
          BasicHeaders,
          Methods73['post']['status']
        >(prefix, PATH57, POST, option).json(),
      /**
       * 招待コードを渡し、招待してくれたユーザーを登録する
       * @param option.body - 招待コード
       * @returns Created
       */
      $post: (option: {
        body: Methods73['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods73['post']['resBody'],
          BasicHeaders,
          Methods73['post']['status']
        >(prefix, PATH57, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH57}`,
    },
    main_favorite_episodes: {
      /**
       * userIDを渡すことで、お気に入りの本編エピソードを取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods74['get']['resBody'],
          BasicHeaders,
          Methods74['get']['status']
        >(prefix, PATH58, GET, option).json(),
      /**
       * userIDを渡すことで、お気に入りの本編エピソードを取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods74['get']['resBody'],
          BasicHeaders,
          Methods74['get']['status']
        >(prefix, PATH58, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH58}`,
    },
    main_favorite_seasons: {
      /**
       * userIDを渡すことで、お気に入りの本編シーズンを取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods75['get']['resBody'],
          BasicHeaders,
          Methods75['get']['status']
        >(prefix, PATH59, GET, option).json(),
      /**
       * userIDを渡すことで、お気に入りの本編シーズンを取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods75['get']['resBody'],
          BasicHeaders,
          Methods75['get']['status']
        >(prefix, PATH59, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH59}`,
    },
    main_viewing_episodes_histories: {
      /**
       * userIDを渡すことで、本編エピソードの視聴履歴を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods76['get']['resBody'],
          BasicHeaders,
          Methods76['get']['status']
        >(prefix, PATH60, GET, option).json(),
      /**
       * userIDを渡すことで、本編エピソードの視聴履歴を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods76['get']['resBody'],
          BasicHeaders,
          Methods76['get']['status']
        >(prefix, PATH60, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH60}`,
    },
    main_viewing_seasons_histories: {
      /**
       * userIDを渡すことで、本編シーズンの視聴履歴を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods77['get']['resBody'],
          BasicHeaders,
          Methods77['get']['status']
        >(prefix, PATH61, GET, option).json(),
      /**
       * userIDを渡すことで、本編シーズンの視聴履歴を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods77['get']['resBody'],
          BasicHeaders,
          Methods77['get']['status']
        >(prefix, PATH61, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH61}`,
    },
    making_favorite_episodes: {
      /**
       * userIDを渡すことで、お気に入りの制作裏側エピソードを取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods78['get']['resBody'],
          BasicHeaders,
          Methods78['get']['status']
        >(prefix, PATH62, GET, option).json(),
      /**
       * userIDを渡すことで、お気に入りの制作裏側エピソードを取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods78['get']['resBody'],
          BasicHeaders,
          Methods78['get']['status']
        >(prefix, PATH62, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH62}`,
    },
    making_favorite_seasons: {
      /**
       * userIDを渡すことで、お気に入りの制作裏側シーズンを取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods79['get']['resBody'],
          BasicHeaders,
          Methods79['get']['status']
        >(prefix, PATH63, GET, option).json(),
      /**
       * userIDを渡すことで、お気に入りの制作裏側シーズンを取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods79['get']['resBody'],
          BasicHeaders,
          Methods79['get']['status']
        >(prefix, PATH63, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH63}`,
    },
    making_viewing_episodes_histories: {
      /**
       * userIDを渡すことで、制作裏側エピソードの視聴履歴を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods80['get']['resBody'],
          BasicHeaders,
          Methods80['get']['status']
        >(prefix, PATH64, GET, option).json(),
      /**
       * userIDを渡すことで、制作裏側エピソードの視聴履歴を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods80['get']['resBody'],
          BasicHeaders,
          Methods80['get']['status']
        >(prefix, PATH64, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH64}`,
    },
    making_viewing_seasons_histories: {
      /**
       * userIDを渡すことで、制作裏側シーズンの視聴履歴を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods81['get']['resBody'],
          BasicHeaders,
          Methods81['get']['status']
        >(prefix, PATH65, GET, option).json(),
      /**
       * userIDを渡すことで、制作裏側シーズンの視聴履歴を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods81['get']['resBody'],
          BasicHeaders,
          Methods81['get']['status']
        >(prefix, PATH65, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH65}`,
    },
    modals: {
      /**
       * モーダルを全て取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods82['get']['resBody'],
          BasicHeaders,
          Methods82['get']['status']
        >(prefix, PATH66, GET, option).json(),
      /**
       * モーダルを全て取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods82['get']['resBody'],
          BasicHeaders,
          Methods82['get']['status']
        >(prefix, PATH66, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH66}`,
    },
    news: {
      _newsId: (val1: string) => {
        const prefix1 = `${PATH67}/${val1}`

        return {
          read: {
            /**
             * お知らせ既読を登録
             */
            post: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods85['post']['status']>(
                prefix,
                `${prefix1}${PATH68}`,
                POST,
                option
              ).send(),
            /**
             * お知らせ既読を登録
             */
            $post: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods85['post']['status']>(
                prefix,
                `${prefix1}${PATH68}`,
                POST,
                option
              )
                .send()
                .then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH68}`,
          },
          /**
           * お知らせ詳細取得
           * @returns OK
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods84['get']['resBody'],
              BasicHeaders,
              Methods84['get']['status']
            >(prefix, prefix1, GET, option).json(),
          /**
           * お知らせ詳細取得
           * @returns OK
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods84['get']['resBody'],
              BasicHeaders,
              Methods84['get']['status']
            >(prefix, prefix1, GET, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      /**
       * お知らせ一覧取得
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods83['get']['resBody'],
          BasicHeaders,
          Methods83['get']['status']
        >(prefix, PATH67, GET, option).json(),
      /**
       * お知らせ一覧取得
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods83['get']['resBody'],
          BasicHeaders,
          Methods83['get']['status']
        >(prefix, PATH67, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH67}`,
    },
    offer_wall: {
      cv: {
        /**
         * OfferWallの確定処理
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods86['get']['resBody'],
            BasicHeaders,
            Methods86['get']['status']
          >(prefix, PATH69, GET, option).json(),
        /**
         * OfferWallの確定処理
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods86['get']['resBody'],
            BasicHeaders,
            Methods86['get']['status']
          >(prefix, PATH69, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH69}`,
      },
    },
    purchased_episode_history: {
      /**
       * エピソードの購入履歴(購入コイン枚数、購入日時を含む)を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods87['get']['resBody'],
          BasicHeaders,
          Methods87['get']['status']
        >(prefix, PATH70, GET, option).json(),
      /**
       * エピソードの購入履歴(購入コイン枚数、購入日時を含む)を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods87['get']['resBody'],
          BasicHeaders,
          Methods87['get']['status']
        >(prefix, PATH70, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH70}`,
    },
    reactions: {
      episodes: {
        _episodeId: (val2: string) => {
          const prefix2 = `${PATH72}/${val2}`

          return {
            /**
             * リアクションのアイコンのUUID, そのリアクションの回数, リアクションのアイコンのURLを取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods89['get']['resBody'],
                BasicHeaders,
                Methods89['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * リアクションのアイコンのUUID, そのリアクションの回数, リアクションのアイコンのURLを取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods89['get']['resBody'],
                BasicHeaders,
                Methods89['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      /**
       * 特定のエピソードに対して、リアクションをする
       * @param option.body - リアクション
       * @returns Created
       */
      post: (option: {
        body: Methods88['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods88['post']['resBody'],
          BasicHeaders,
          Methods88['post']['status']
        >(prefix, PATH71, POST, option).json(),
      /**
       * 特定のエピソードに対して、リアクションをする
       * @param option.body - リアクション
       * @returns Created
       */
      $post: (option: {
        body: Methods88['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods88['post']['resBody'],
          BasicHeaders,
          Methods88['post']['status']
        >(prefix, PATH71, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH71}`,
    },
    report_masters: {
      /**
       * コメントを報告するときの理由を取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods90['get']['resBody'],
          BasicHeaders,
          Methods90['get']['status']
        >(prefix, PATH73, GET, option).json(),
      /**
       * コメントを報告するときの理由を取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods90['get']['resBody'],
          BasicHeaders,
          Methods90['get']['status']
        >(prefix, PATH73, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH73}`,
    },
    reports: {
      /**
       * コメントを報告する
       * @param option.body - コメントを報告する内容
       * @returns Created
       */
      post: (option: {
        body: Methods91['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods91['post']['resBody'],
          BasicHeaders,
          Methods91['post']['status']
        >(prefix, PATH74, POST, option).json(),
      /**
       * コメントを報告する
       * @param option.body - コメントを報告する内容
       * @returns Created
       */
      $post: (option: {
        body: Methods91['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods91['post']['resBody'],
          BasicHeaders,
          Methods91['post']['status']
        >(prefix, PATH74, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH74}`,
    },
    search: {
      /**
       * 検索結果を取得する
       * @returns OK
       */
      get: (option: {
        query: Methods92['get']['query']
        config?: T | undefined
      }) =>
        fetch<
          Methods92['get']['resBody'],
          BasicHeaders,
          Methods92['get']['status']
        >(prefix, PATH75, GET, option).json(),
      /**
       * 検索結果を取得する
       * @returns OK
       */
      $get: (option: {
        query: Methods92['get']['query']
        config?: T | undefined
      }) =>
        fetch<
          Methods92['get']['resBody'],
          BasicHeaders,
          Methods92['get']['status']
        >(prefix, PATH75, GET, option)
          .json()
          .then(r => r.body),
      $path: (
        option?:
          | { method?: 'get' | undefined; query: Methods92['get']['query'] }
          | undefined
      ) =>
        `${prefix}${PATH75}${
          option && option.query ? `?${dataToURLString(option.query)}` : ''
        }`,
    },
    seasons: {
      digests: {
        _projectMasterId: (val2: string) => {
          const prefix2 = `${PATH76}/${val2}`

          return {
            /**
             * ダイジェスト画面に表示するための情報を取得する
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods93['get']['resBody'],
                BasicHeaders,
                Methods93['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * ダイジェスト画面に表示するための情報を取得する
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods93['get']['resBody'],
                BasicHeaders,
                Methods93['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      order_create: {
        /**
         * シーズンを新着順に取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods94['get']['resBody'],
            BasicHeaders,
            Methods94['get']['status']
          >(prefix, PATH77, GET, option).json(),
        /**
         * シーズンを新着順に取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods94['get']['resBody'],
            BasicHeaders,
            Methods94['get']['status']
          >(prefix, PATH77, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH77}`,
      },
    },
    topics: {
      _id: (val1: string) => {
        const prefix1 = `${PATH78}/${val1}`

        return {
          /**
           * idを渡して、トピックスを論理削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods96['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * idを渡して、トピックスを論理削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods96['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      _topicId: (val1: string) => {
        const prefix1 = `${PATH78}/${val1}`

        return {
          creators: {
            list_up: {
              /**
               * creatorsテーブルから、運営がリストアップしたクリエイターを取得する
               * @returns OK
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods97['get']['resBody'],
                  BasicHeaders,
                  Methods97['get']['status']
                >(prefix, `${prefix1}${PATH79}`, GET, option).json(),
              /**
               * creatorsテーブルから、運営がリストアップしたクリエイターを取得する
               * @returns OK
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods97['get']['resBody'],
                  BasicHeaders,
                  Methods97['get']['status']
                >(prefix, `${prefix1}${PATH79}`, GET, option)
                  .json()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix1}${PATH79}`,
            },
          },
          episodes: {
            list_up: {
              /**
               * 運営がリストアップしたエピソードを取得する
               * @returns OK
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods98['get']['resBody'],
                  BasicHeaders,
                  Methods98['get']['status']
                >(prefix, `${prefix1}${PATH80}`, GET, option).json(),
              /**
               * 運営がリストアップしたエピソードを取得する
               * @returns OK
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods98['get']['resBody'],
                  BasicHeaders,
                  Methods98['get']['status']
                >(prefix, `${prefix1}${PATH80}`, GET, option)
                  .json()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix1}${PATH80}`,
            },
          },
          season: {
            episodes: {
              /**
               * 運営が選んだシーズンのエピソードを昇順もしくは降順で取得する
               * @returns OK
               */
              get: (option: {
                query: Methods99['get']['query']
                config?: T | undefined
              }) =>
                fetch<
                  Methods99['get']['resBody'],
                  BasicHeaders,
                  Methods99['get']['status']
                >(prefix, `${prefix1}${PATH81}`, GET, option).json(),
              /**
               * 運営が選んだシーズンのエピソードを昇順もしくは降順で取得する
               * @returns OK
               */
              $get: (option: {
                query: Methods99['get']['query']
                config?: T | undefined
              }) =>
                fetch<
                  Methods99['get']['resBody'],
                  BasicHeaders,
                  Methods99['get']['status']
                >(prefix, `${prefix1}${PATH81}`, GET, option)
                  .json()
                  .then(r => r.body),
              $path: (
                option?:
                  | {
                      method?: 'get' | undefined
                      query: Methods99['get']['query']
                    }
                  | undefined
              ) =>
                `${prefix}${prefix1}${PATH81}${
                  option && option.query
                    ? `?${dataToURLString(option.query)}`
                    : ''
                }`,
            },
          },
          seasons: {
            list_up: {
              /**
               * 運営がリストアップしたシーズンを取得する
               * @returns OK
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods100['get']['resBody'],
                  BasicHeaders,
                  Methods100['get']['status']
                >(prefix, `${prefix1}${PATH82}`, GET, option).json(),
              /**
               * 運営がリストアップしたシーズンを取得する
               * @returns OK
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods100['get']['resBody'],
                  BasicHeaders,
                  Methods100['get']['status']
                >(prefix, `${prefix1}${PATH82}`, GET, option)
                  .json()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix1}${PATH82}`,
            },
          },
          works: {
            list_up: {
              /**
               * 運営がリストアップした作品を取得する
               * @returns OK
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods101['get']['resBody'],
                  BasicHeaders,
                  Methods101['get']['status']
                >(prefix, `${prefix1}${PATH83}`, GET, option).json(),
              /**
               * 運営がリストアップした作品を取得する
               * @returns OK
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods101['get']['resBody'],
                  BasicHeaders,
                  Methods101['get']['status']
                >(prefix, `${prefix1}${PATH83}`, GET, option)
                  .json()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix1}${PATH83}`,
            },
          },
        }
      },
      /**
       * トピックスを全て取得する
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods95['get']['resBody'],
          BasicHeaders,
          Methods95['get']['status']
        >(prefix, PATH78, GET, option).json(),
      /**
       * トピックスを全て取得する
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods95['get']['resBody'],
          BasicHeaders,
          Methods95['get']['status']
        >(prefix, PATH78, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH78}`,
    },
    user_notifications: {
      /**
       * 通知一覧の取得
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods102['get']['resBody'],
          BasicHeaders,
          Methods102['get']['status']
        >(prefix, PATH84, GET, option).json(),
      /**
       * 通知一覧の取得
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods102['get']['resBody'],
          BasicHeaders,
          Methods102['get']['status']
        >(prefix, PATH84, GET, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH84}`,
    },
    user_season_notification: {
      seasons: {
        _seasonId: (val2: string) => {
          const prefix2 = `${PATH86}/${val2}`

          return {
            /**
             * seasonIDとuserIDを渡し、そのseasonIDに紐づくシーズンの更新通知をオフにする
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods104['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              ).send(),
            /**
             * seasonIDとuserIDを渡し、そのseasonIDに紐づくシーズンの更新通知をオフにする
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods104['delete']['status']>(
                prefix,
                prefix2,
                DELETE,
                option
              )
                .send()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      /**
       * seasonIDとuserIDを渡し、そのseasonIDに紐づくシーズンの更新通知をオンにする
       * @param option.body - シーズンのUUID
       * @returns Created
       */
      post: (option: {
        body: Methods103['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods103['post']['resBody'],
          BasicHeaders,
          Methods103['post']['status']
        >(prefix, PATH85, POST, option).json(),
      /**
       * seasonIDとuserIDを渡し、そのseasonIDに紐づくシーズンの更新通知をオンにする
       * @param option.body - シーズンのUUID
       * @returns Created
       */
      $post: (option: {
        body: Methods103['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods103['post']['resBody'],
          BasicHeaders,
          Methods103['post']['status']
        >(prefix, PATH85, POST, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH85}`,
    },
    user_settings: {
      campaign_and_new_season_notifications: {
        /**
         * 新作の公開/キャンペーン通知の更新
         * @returns OK
         */
        put: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods105['put']['resBody'],
            BasicHeaders,
            Methods105['put']['status']
          >(prefix, PATH87, PUT, option).json(),
        /**
         * 新作の公開/キャンペーン通知の更新
         * @returns OK
         */
        $put: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods105['put']['resBody'],
            BasicHeaders,
            Methods105['put']['status']
          >(prefix, PATH87, PUT, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH87}`,
      },
      comment_reply_notifications: {
        /**
         * いいね/リプライ通知の更新
         * @returns OK
         */
        put: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods106['put']['resBody'],
            BasicHeaders,
            Methods106['put']['status']
          >(prefix, PATH88, PUT, option).json(),
        /**
         * いいね/リプライ通知の更新
         * @returns OK
         */
        $put: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods106['put']['resBody'],
            BasicHeaders,
            Methods106['put']['status']
          >(prefix, PATH88, PUT, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH88}`,
      },
      news_notifications: {
        /**
         * 運営からのお知らせ通知の更新
         * @returns OK
         */
        put: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods107['put']['resBody'],
            BasicHeaders,
            Methods107['put']['status']
          >(prefix, PATH89, PUT, option).json(),
        /**
         * 運営からのお知らせ通知の更新
         * @returns OK
         */
        $put: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods107['put']['resBody'],
            BasicHeaders,
            Methods107['put']['status']
          >(prefix, PATH89, PUT, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH89}`,
      },
    },
    users: {
      _providerName: (val1: string) => {
        const prefix1 = `${PATH90}/${val1}`

        return {
          _providerSub: (val2: string) => {
            const prefix2 = `${prefix1}/${val2}`

            return {
              /**
               * Providerに紐づくユーザーIDの取得
               * @returns OK
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods109['get']['resBody'],
                  BasicHeaders,
                  Methods109['get']['status']
                >(prefix, prefix2, GET, option).json(),
              /**
               * Providerに紐づくユーザーIDの取得
               * @returns OK
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<
                  Methods109['get']['resBody'],
                  BasicHeaders,
                  Methods109['get']['status']
                >(prefix, prefix2, GET, option)
                  .json()
                  .then(r => r.body),
              /**
               * Providerに紐づくユーザー情報の存在を確認
               */
              head: (option?: { config?: T | undefined } | undefined) =>
                fetch<void, BasicHeaders, Methods109['head']['status']>(
                  prefix,
                  prefix2,
                  HEAD,
                  option
                ).send(),
              /**
               * Providerに紐づくユーザー情報の存在を確認
               */
              $head: (option?: { config?: T | undefined } | undefined) =>
                fetch<void, BasicHeaders, Methods109['head']['status']>(
                  prefix,
                  prefix2,
                  HEAD,
                  option
                )
                  .send()
                  .then(r => r.body),
              $path: () => `${prefix}${prefix2}`,
            }
          },
        }
      },
      _userName: (val1: string) => {
        const prefix1 = `${PATH90}/${val1}`

        return {
          /**
           * 特定ユーザー名の存在を確認
           */
          head: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods110['head']['status']>(
              prefix,
              prefix1,
              HEAD,
              option
            ).send(),
          /**
           * 特定ユーザー名の存在を確認
           */
          $head: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods110['head']['status']>(
              prefix,
              prefix1,
              HEAD,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      account_inheritance: {
        after_registration: {
          /**
           * SNSアカウントによるユーザー情報の引き継ぎ(アカウント登録後)
           * @param option.body - 継承元ユーザーID
           */
          post: (option: {
            body: Methods111['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods111['post']['status']>(
              prefix,
              PATH91,
              POST,
              option
            ).send(),
          /**
           * SNSアカウントによるユーザー情報の引き継ぎ(アカウント登録後)
           * @param option.body - 継承元ユーザーID
           */
          $post: (option: {
            body: Methods111['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods111['post']['status']>(
              prefix,
              PATH91,
              POST,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${PATH91}`,
        },
        before_registration: {
          /**
           * SNSアカウントによるユーザー情報の引き継ぎ(アカウント登録前)
           * @param option.body - 継承元ユーザーID
           */
          post: (option: {
            body: Methods112['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods112['post']['status']>(
              prefix,
              PATH92,
              POST,
              option
            ).send(),
          /**
           * SNSアカウントによるユーザー情報の引き継ぎ(アカウント登録前)
           * @param option.body - 継承元ユーザーID
           */
          $post: (option: {
            body: Methods112['post']['reqBody']
            config?: T | undefined
          }) =>
            fetch<void, BasicHeaders, Methods112['post']['status']>(
              prefix,
              PATH92,
              POST,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${PATH92}`,
        },
      },
      block: {
        /**
         * ユーザーをブロックする
         * @param option.body - 対象のコメント
         * @returns Created
         */
        post: (option: {
          body: Methods113['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods113['post']['resBody'],
            BasicHeaders,
            Methods113['post']['status']
          >(prefix, PATH93, POST, option).json(),
        /**
         * ユーザーをブロックする
         * @param option.body - 対象のコメント
         * @returns Created
         */
        $post: (option: {
          body: Methods113['post']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods113['post']['resBody'],
            BasicHeaders,
            Methods113['post']['status']
          >(prefix, PATH93, POST, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH93}`,
      },
      check_name: {
        _userName: (val2: string) => {
          const prefix2 = `${PATH94}/${val2}`

          return {
            /**
             * ユーザー名が有効かどうかを確認
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods114['get']['status']>(
                prefix,
                prefix2,
                GET,
                option
              ).send(),
            /**
             * ユーザー名が有効かどうかを確認
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods114['get']['status']>(
                prefix,
                prefix2,
                GET,
                option
              )
                .send()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
      fcm_token: {
        /**
         * FCMトークンの更新
         * @param option.body - 更新データ
         * @returns OK
         */
        patch: (option: {
          body: Methods115['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods115['patch']['resBody'],
            BasicHeaders,
            Methods115['patch']['status']
          >(prefix, PATH95, PATCH, option).json(),
        /**
         * FCMトークンの更新
         * @param option.body - 更新データ
         * @returns OK
         */
        $patch: (option: {
          body: Methods115['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods115['patch']['resBody'],
            BasicHeaders,
            Methods115['patch']['status']
          >(prefix, PATH95, PATCH, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH95}`,
      },
      firebaseUserId: {
        /**
         * アカウントをすでに登録しているユーザーか確認
         */
        head: (option?: { config?: T | undefined } | undefined) =>
          fetch<void, BasicHeaders, Methods116['head']['status']>(
            prefix,
            PATH96,
            HEAD,
            option
          ).send(),
        /**
         * アカウントをすでに登録しているユーザーか確認
         */
        $head: (option?: { config?: T | undefined } | undefined) =>
          fetch<void, BasicHeaders, Methods116['head']['status']>(
            prefix,
            PATH96,
            HEAD,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH96}`,
      },
      inherited: {
        /**
         * アカウント引き継ぎされたユーザーか確認
         */
        head: (option?: { config?: T | undefined } | undefined) =>
          fetch<void, BasicHeaders, Methods117['head']['status']>(
            prefix,
            PATH97,
            HEAD,
            option
          ).send(),
        /**
         * アカウント引き継ぎされたユーザーか確認
         */
        $head: (option?: { config?: T | undefined } | undefined) =>
          fetch<void, BasicHeaders, Methods117['head']['status']>(
            prefix,
            PATH97,
            HEAD,
            option
          )
            .send()
            .then(r => r.body),
        $path: () => `${prefix}${PATH97}`,
      },
      providers: {
        /**
         * プロバイダー情報の更新
         * @param option.body - 更新データ
         * @returns OK
         */
        patch: (option: {
          body: Methods118['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods118['patch']['resBody'],
            BasicHeaders,
            Methods118['patch']['status']
          >(prefix, PATH98, PATCH, option).json(),
        /**
         * プロバイダー情報の更新
         * @param option.body - 更新データ
         * @returns OK
         */
        $patch: (option: {
          body: Methods118['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods118['patch']['resBody'],
            BasicHeaders,
            Methods118['patch']['status']
          >(prefix, PATH98, PATCH, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH98}`,
      },
      signup: {
        validate: {
          /**
           * アカウントの名前が既に存在しているかどうかチェックする
           * @returns OK
           */
          get: (option: {
            query: Methods119['get']['query']
            config?: T | undefined
          }) =>
            fetch<
              Methods119['get']['resBody'],
              BasicHeaders,
              Methods119['get']['status']
            >(prefix, PATH99, GET, option).json(),
          /**
           * アカウントの名前が既に存在しているかどうかチェックする
           * @returns OK
           */
          $get: (option: {
            query: Methods119['get']['query']
            config?: T | undefined
          }) =>
            fetch<
              Methods119['get']['resBody'],
              BasicHeaders,
              Methods119['get']['status']
            >(prefix, PATH99, GET, option)
              .json()
              .then(r => r.body),
          $path: (
            option?:
              | {
                  method?: 'get' | undefined
                  query: Methods119['get']['query']
                }
              | undefined
          ) =>
            `${prefix}${PATH99}${
              option && option.query ? `?${dataToURLString(option.query)}` : ''
            }`,
        },
      },
      viewed_news: {
        /**
         * 運営からのお知らせの視聴履歴を更新
         * @param option.body - 更新データ
         * @returns OK
         */
        patch: (option: {
          body: Methods120['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods120['patch']['resBody'],
            BasicHeaders,
            Methods120['patch']['status']
          >(prefix, PATH100, PATCH, option).json(),
        /**
         * 運営からのお知らせの視聴履歴を更新
         * @param option.body - 更新データ
         * @returns OK
         */
        $patch: (option: {
          body: Methods120['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods120['patch']['resBody'],
            BasicHeaders,
            Methods120['patch']['status']
          >(prefix, PATH100, PATCH, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH100}`,
      },
      viewed_notifications: {
        /**
         * 通知の視聴履歴を更新
         * @param option.body - 更新データ
         * @returns OK
         */
        patch: (option: {
          body: Methods121['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods121['patch']['resBody'],
            BasicHeaders,
            Methods121['patch']['status']
          >(prefix, PATH101, PATCH, option).json(),
        /**
         * 通知の視聴履歴を更新
         * @param option.body - 更新データ
         * @returns OK
         */
        $patch: (option: {
          body: Methods121['patch']['reqBody']
          config?: T | undefined
        }) =>
          fetch<
            Methods121['patch']['resBody'],
            BasicHeaders,
            Methods121['patch']['status']
          >(prefix, PATH101, PATCH, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH101}`,
      },
      /**
       * ユーザー詳細の取得
       * @returns OK
       */
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods108['get']['resBody'],
          BasicHeaders,
          Methods108['get']['status']
        >(prefix, PATH90, GET, option).json(),
      /**
       * ユーザー詳細の取得
       * @returns OK
       */
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<
          Methods108['get']['resBody'],
          BasicHeaders,
          Methods108['get']['status']
        >(prefix, PATH90, GET, option)
          .json()
          .then(r => r.body),
      /**
       * ユーザーの新規追加
       * @param option.body - 登録データ
       * @returns Created
       */
      post: (option: {
        body: Methods108['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods108['post']['resBody'],
          BasicHeaders,
          Methods108['post']['status']
        >(prefix, PATH90, POST, option).json(),
      /**
       * ユーザーの新規追加
       * @param option.body - 登録データ
       * @returns Created
       */
      $post: (option: {
        body: Methods108['post']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods108['post']['resBody'],
          BasicHeaders,
          Methods108['post']['status']
        >(prefix, PATH90, POST, option)
          .json()
          .then(r => r.body),
      /**
       * プロフィールの更新
       * @param option.body - 更新データ
       * @returns OK
       */
      patch: (option: {
        body: Methods108['patch']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods108['patch']['resBody'],
          BasicHeaders,
          Methods108['patch']['status']
        >(prefix, PATH90, PATCH, option).json(),
      /**
       * プロフィールの更新
       * @param option.body - 更新データ
       * @returns OK
       */
      $patch: (option: {
        body: Methods108['patch']['reqBody']
        config?: T | undefined
      }) =>
        fetch<
          Methods108['patch']['resBody'],
          BasicHeaders,
          Methods108['patch']['status']
        >(prefix, PATH90, PATCH, option)
          .json()
          .then(r => r.body),
      $path: () => `${prefix}${PATH90}`,
    },
    viewing_episode_histories: {
      _episodeId: (val1: string) => {
        const prefix1 = `${PATH102}/${val1}`

        return {
          /**
           * エピソード履歴の追加
           * @param option.body - 登録・更新データ
           * @returns OK
           */
          put: (option: {
            body: Methods122['put']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods122['put']['resBody'],
              BasicHeaders,
              Methods122['put']['status']
            >(prefix, prefix1, PUT, option).json(),
          /**
           * エピソード履歴の追加
           * @param option.body - 登録・更新データ
           * @returns OK
           */
          $put: (option: {
            body: Methods122['put']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods122['put']['resBody'],
              BasicHeaders,
              Methods122['put']['status']
            >(prefix, prefix1, PUT, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      ranking: {
        /**
         * 全ユーザーのエピソード視聴履歴を回数の多い順に返却
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods123['get']['resBody'],
            BasicHeaders,
            Methods123['get']['status']
          >(prefix, PATH103, GET, option).json(),
        /**
         * 全ユーザーのエピソード視聴履歴を回数の多い順に返却
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods123['get']['resBody'],
            BasicHeaders,
            Methods123['get']['status']
          >(prefix, PATH103, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH103}`,
      },
    },
    viewing_episode_history: {
      _id: (val1: string) => {
        const prefix1 = `${PATH104}/${val1}`

        return {
          /**
           * IDを渡して、エピソードの視聴履歴を削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods124['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * IDを渡して、エピソードの視聴履歴を削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods124['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
    },
    viewing_season_histories: {
      _seasonId: (val1: string) => {
        const prefix1 = `${PATH105}/${val1}`

        return {
          /**
           * シーズン履歴の追加
           * @param option.body - 登録・更新データ
           * @returns OK
           */
          put: (option: {
            body: Methods125['put']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods125['put']['resBody'],
              BasicHeaders,
              Methods125['put']['status']
            >(prefix, prefix1, PUT, option).json(),
          /**
           * シーズン履歴の追加
           * @param option.body - 登録・更新データ
           * @returns OK
           */
          $put: (option: {
            body: Methods125['put']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods125['put']['resBody'],
              BasicHeaders,
              Methods125['put']['status']
            >(prefix, prefix1, PUT, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      ranking: {
        /**
         * 全ユーザーのシーズン視聴履歴を回数の多い順に返却
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods126['get']['resBody'],
            BasicHeaders,
            Methods126['get']['status']
          >(prefix, PATH106, GET, option).json(),
        /**
         * 全ユーザーのシーズン視聴履歴を回数の多い順に返却
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods126['get']['resBody'],
            BasicHeaders,
            Methods126['get']['status']
          >(prefix, PATH106, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH106}`,
      },
    },
    viewing_season_history: {
      _id: (val1: string) => {
        const prefix1 = `${PATH107}/${val1}`

        return {
          /**
           * IDを渡して、シーズンの視聴履歴を削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods127['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * IDを渡して、シーズンの視聴履歴を削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods127['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
    },
    viewing_work_histories: {
      _workId: (val1: string) => {
        const prefix1 = `${PATH108}/${val1}`

        return {
          /**
           * ユーザーIDを渡して作品の視聴履歴を追加する
           * @param option.body - 登録・更新データ
           * @returns OK
           */
          put: (option: {
            body: Methods128['put']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods128['put']['resBody'],
              BasicHeaders,
              Methods128['put']['status']
            >(prefix, prefix1, PUT, option).json(),
          /**
           * ユーザーIDを渡して作品の視聴履歴を追加する
           * @param option.body - 登録・更新データ
           * @returns OK
           */
          $put: (option: {
            body: Methods128['put']['reqBody']
            config?: T | undefined
          }) =>
            fetch<
              Methods128['put']['resBody'],
              BasicHeaders,
              Methods128['put']['status']
            >(prefix, prefix1, PUT, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      ranking: {
        /**
         * 全ユーザーの作品視聴履歴を回数の多い順に返却
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods129['get']['resBody'],
            BasicHeaders,
            Methods129['get']['status']
          >(prefix, PATH109, GET, option).json(),
        /**
         * 全ユーザーの作品視聴履歴を回数の多い順に返却
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods129['get']['resBody'],
            BasicHeaders,
            Methods129['get']['status']
          >(prefix, PATH109, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH109}`,
      },
    },
    viewing_work_history: {
      _id: (val1: string) => {
        const prefix1 = `${PATH110}/${val1}`

        return {
          /**
           * ユーザーIDを渡して作品の視聴履歴を削除する
           */
          delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods130['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            ).send(),
          /**
           * ユーザーIDを渡して作品の視聴履歴を削除する
           */
          $delete: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods130['delete']['status']>(
              prefix,
              prefix1,
              DELETE,
              option
            )
              .send()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
    },
    web: {
      episodes: {
        _episodeId: (val2: string) => {
          const prefix2 = `${PATH111}/${val2}`

          return {
            /**
             * episodeIDを渡すことで、エピソード詳細の取得
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods131['get']['resBody'],
                BasicHeaders,
                Methods131['get']['status']
              >(prefix, prefix2, GET, option).json(),
            /**
             * episodeIDを渡すことで、エピソード詳細の取得
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods131['get']['resBody'],
                BasicHeaders,
                Methods131['get']['status']
              >(prefix, prefix2, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          }
        },
      },
    },
    works: {
      _workId: (val1: string) => {
        const prefix1 = `${PATH112}/${val1}`

        return {
          recovery_time: {
            /**
             * 待てば無料のチャージ時間を返す(チャージ満タンの場合はから文字列)
             * @returns OK
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods133['get']['resBody'],
                BasicHeaders,
                Methods133['get']['status']
              >(prefix, `${prefix1}${PATH113}`, GET, option).json(),
            /**
             * 待てば無料のチャージ時間を返す(チャージ満タンの場合はから文字列)
             * @returns OK
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<
                Methods133['get']['resBody'],
                BasicHeaders,
                Methods133['get']['status']
              >(prefix, `${prefix1}${PATH113}`, GET, option)
                .json()
                .then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH113}`,
          },
          /**
           * 作品詳細の取得
           * @returns OK
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods132['get']['resBody'],
              BasicHeaders,
              Methods132['get']['status']
            >(prefix, prefix1, GET, option).json(),
          /**
           * 作品詳細の取得
           * @returns OK
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<
              Methods132['get']['resBody'],
              BasicHeaders,
              Methods132['get']['status']
            >(prefix, prefix1, GET, option)
              .json()
              .then(r => r.body),
          $path: () => `${prefix}${prefix1}`,
        }
      },
      order_create: {
        /**
         * 作品一覧を新着順に取得する
         * @returns OK
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods134['get']['resBody'],
            BasicHeaders,
            Methods134['get']['status']
          >(prefix, PATH114, GET, option).json(),
        /**
         * 作品一覧を新着順に取得する
         * @returns OK
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<
            Methods134['get']['resBody'],
            BasicHeaders,
            Methods134['get']['status']
          >(prefix, PATH114, GET, option)
            .json()
            .then(r => r.body),
        $path: () => `${prefix}${PATH114}`,
      },
    },
  }
}

export type ApiInstance = ReturnType<typeof api>
export default api
